import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Date: any;
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: any;
  Decimal: any;
};

export enum AccountabilityComprobationKind {
  BankStatements = 'BANK_STATEMENTS',
  BankTransferReceipt = 'BANK_TRANSFER_RECEIPT',
  BillPaymentReceipt = 'BILL_PAYMENT_RECEIPT',
  CreditCardReceipt = 'CREDIT_CARD_RECEIPT',
  FinancialStatements = 'FINANCIAL_STATEMENTS',
  Invoice = 'INVOICE',
  Others = 'OTHERS',
  Receipt = 'RECEIPT',
  ServiceOwnHandReceipt = 'SERVICE_OWN_HAND_RECEIPT',
  VehicleBillOfSale = 'VEHICLE_BILL_OF_SALE'
}

export enum AccountabilityDestinationKind {
  BusinessExpansionRebuild = 'BUSINESS_EXPANSION_REBUILD',
  BusinessLawConsulting = 'BUSINESS_LAW_CONSULTING',
  ConsumptionBill = 'CONSUMPTION_BILL',
  EmployeesPayment = 'EMPLOYEES_PAYMENT',
  EquipmentMachinesAcquisitionRepair = 'EQUIPMENT_MACHINES_ACQUISITION_REPAIR',
  Marketing = 'MARKETING',
  MotorcyclesAcquisitionRepair = 'MOTORCYCLES_ACQUISITION_REPAIR',
  Others = 'OTHERS',
  ProvidersDebts = 'PROVIDERS_DEBTS',
  ResearchInnovation = 'RESEARCH_INNOVATION',
  ServicesAssetsAcquisition = 'SERVICES_ASSETS_ACQUISITION',
  SoftwareHardwareAcquisitionRepair = 'SOFTWARE_HARDWARE_ACQUISITION_REPAIR',
  Stock = 'STOCK',
  ThirdPayments = 'THIRD_PAYMENTS',
  ToolsAcquisitionRepair = 'TOOLS_ACQUISITION_REPAIR',
  Training = 'TRAINING',
  UtilityVehicleAcquisitionRepair = 'UTILITY_VEHICLE_ACQUISITION_REPAIR',
  WorkingCapital = 'WORKING_CAPITAL'
}

export type AccountabilityDocument = {
  comprobationKind?: Maybe<AccountabilityComprobationKind>;
  date?: Maybe<Scalars['Date']>;
  destinationKind?: Maybe<AccountabilityDestinationKind>;
  fileName?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type AccountabilityDocumentInput = {
  comprobationKind?: InputMaybe<AccountabilityComprobationKind>;
  date?: InputMaybe<Scalars['Date']>;
  destinationKind?: InputMaybe<AccountabilityDestinationKind>;
  fileName?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type Address = {
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['ID']>;
  complement?: Maybe<Scalars['String']>;
  neighbourhood?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  cityId?: InputMaybe<Scalars['ID']>;
  complement?: InputMaybe<Scalars['String']>;
  neighbourhood?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AlienatedItem = {
  description?: Maybe<Scalars['String']>;
  fabricator?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  serialNumber?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type Answer = {
  answerText?: Maybe<Scalars['String']>;
  answerType?: Maybe<AnswerType>;
  booleanReply?: Maybe<Scalars['Boolean']>;
  cancelAnswers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  contentType?: Maybe<ContentType>;
  dependsOfAnswers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  discursiveReply?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  showOnResume?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
};

export type AnswerInput = {
  answerText: Scalars['String'];
  answerType?: InputMaybe<AnswerType>;
  booleanReply?: InputMaybe<Scalars['Boolean']>;
  cancelAnswers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contentType?: InputMaybe<ContentType>;
  dependsOfAnswers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  discursiveReply?: InputMaybe<Scalars['String']>;
  number: Scalars['Int'];
  showOnResume?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export enum AnswerType {
  Boolean = 'BOOLEAN',
  Discursive = 'DISCURSIVE'
}

export type AntiFraud = {
  applicant?: Maybe<Applicant>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  livenessStatus?: Maybe<LivenessStatus>;
  worthyCreditStatus?: Maybe<WorthyCreditStatus>;
};

export type Applicant = {
  relationship?: Maybe<ApplicantRelationship>;
};

export type ApplicantInput = {
  document?: InputMaybe<Scalars['String']>;
  loanApplicationId?: InputMaybe<Scalars['ID']>;
};

export enum ApplicantRelationship {
  NonRequestingPartner = 'NON_REQUESTING_PARTNER',
  RequestingPartner = 'REQUESTING_PARTNER',
  UnknownNonRequestingPartner = 'UNKNOWN_NON_REQUESTING_PARTNER',
  UnknownRequestingPartner = 'UNKNOWN_REQUESTING_PARTNER'
}

export type ApplicantResultType = Applicant | InvalidApplicant;

export enum AuthorityDecisionKind {
  Approve = 'APPROVE',
  ApproveWithChanges = 'APPROVE_WITH_CHANGES',
  ManualAnalysis = 'MANUAL_ANALYSIS',
  Reprove = 'REPROVE'
}

export type AuthorityDecisionReason = {
  amount?: Maybe<Scalars['Decimal']>;
  assignmentCommissionModifier?: Maybe<Scalars['Decimal']>;
  bizuCombo?: Maybe<Scalars['Decimal']>;
  decision?: Maybe<AuthorityDecisionKind>;
  informedRevenue?: Maybe<Scalars['Decimal']>;
  interestRate?: Maybe<Scalars['Decimal']>;
  needPsychometric?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tenure?: Maybe<Scalars['Int']>;
  verifiedRevenue?: Maybe<Scalars['Decimal']>;
};

export type AuthorityDecisionReasonInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  assignmentCommissionModifier?: InputMaybe<Scalars['Decimal']>;
  bizuCombo?: InputMaybe<Scalars['Decimal']>;
  decision?: InputMaybe<AuthorityDecisionKind>;
  informedRevenue?: InputMaybe<Scalars['Decimal']>;
  interestRate?: InputMaybe<Scalars['Decimal']>;
  needPsychometric?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  verifiedRevenue?: InputMaybe<Scalars['Decimal']>;
};

export enum AuthorityLevel {
  FirstAuthority = 'FIRST_AUTHORITY',
  SecondAuthority = 'SECOND_AUTHORITY',
  ThirdAuthority = 'THIRD_AUTHORITY'
}

export type AutomaticAuthorityDecision = {
  decision?: Maybe<AuthorityDecisionKind>;
  reason?: Maybe<Array<Maybe<AuthorityDecisionReason>>>;
  revenueComprovationRatio?: Maybe<Scalars['Decimal']>;
  verifiedRevenue?: Maybe<Scalars['String']>;
};

export type AutomaticAuthorityDecisionCache = {
  data?: Maybe<AutomaticAuthorityDecision>;
  processing?: Maybe<Scalars['Boolean']>;
};

export type AutomaticAuthorityDecisionInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  assignmentCommissionModifier?: InputMaybe<Scalars['Decimal']>;
  creditAnalysisId?: InputMaybe<Scalars['ID']>;
  decision?: InputMaybe<AuthorityDecisionKind>;
  interestRate?: InputMaybe<Scalars['Decimal']>;
  loanApplicationId?: InputMaybe<Scalars['ID']>;
  needPsychometric?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Array<InputMaybe<AuthorityDecisionReasonInput>>>;
  revenueComprovationRatio?: InputMaybe<Scalars['Decimal']>;
  success?: InputMaybe<Scalars['Boolean']>;
  tenure?: InputMaybe<Scalars['Int']>;
  verifiedRevenue?: InputMaybe<Scalars['String']>;
};

export type Bank = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mostUsed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type BankAccount = {
  account?: Maybe<Scalars['String']>;
  agency?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['ID']>;
  isAutomaticDebit?: Maybe<Scalars['Boolean']>;
  isBizConta?: Maybe<Scalars['Boolean']>;
  isLegalPersonAccount?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type BankAccountInfo = {
  account?: Maybe<Scalars['String']>;
  agency?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
};

export type BankAccountInfoInput = {
  account?: InputMaybe<Scalars['String']>;
  agency?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
};

export type BankAccountInput = {
  account?: InputMaybe<Scalars['String']>;
  agency?: InputMaybe<Scalars['String']>;
  bankId?: InputMaybe<Scalars['ID']>;
  isAutomaticDebit?: InputMaybe<Scalars['Boolean']>;
  isBizConta?: InputMaybe<Scalars['Boolean']>;
  isLegalPersonAccount?: InputMaybe<Scalars['Boolean']>;
};

export type Borrower = {
  activitySector?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  bankAccount?: Maybe<BankAccount>;
  cnae?: Maybe<Scalars['String']>;
  cnaeCode?: Maybe<Scalars['String']>;
  companyDocument?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  foundationDate?: Maybe<Scalars['Date']>;
  isMEI?: Maybe<Scalars['Boolean']>;
  legacyRelationship?: Maybe<Credit_LegacyRelationship>;
  legalNature?: Maybe<Scalars['String']>;
  monthlyRevenue?: Maybe<Scalars['Decimal']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<BorrowerRelationship>;
  responsibleDocument?: Maybe<Scalars['String']>;
  responsibleName?: Maybe<Scalars['String']>;
  simplesNacional?: Maybe<Scalars['Boolean']>;
  stateRegistration?: Maybe<Scalars['String']>;
  yearlyRevenue?: Maybe<Scalars['Decimal']>;
};

export type BorrowerInfo = {
  bankAccount?: Maybe<BankAccountInfo>;
};

export type BorrowerInfoInput = {
  bankAccount?: InputMaybe<BankAccountInfoInput>;
};

export enum BorrowerRelationship {
  Administrator = 'ADMINISTRATOR',
  Attorney = 'ATTORNEY',
  FinanceManager = 'FINANCE_MANAGER',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  PartnerAdministrator = 'PARTNER_ADMINISTRATOR',
  President = 'PRESIDENT'
}

export type ChangeTracker = {
  date?: Maybe<Scalars['DateTime']>;
};

export type ChangeTrackerInput = {
  date?: InputMaybe<Scalars['DateTime']>;
};

export type Checklist = {
  isCompleted?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
};

export type ChecklistInput = {
  items?: InputMaybe<Array<InputMaybe<ChecklistItemInput>>>;
};

export type ChecklistItem = {
  allowedDocuments?: Maybe<Array<Maybe<DocumentType>>>;
  externalNotification?: Maybe<Scalars['Boolean']>;
  observation?: Maybe<Scalars['String']>;
  origin?: Maybe<ChecklistItemOrigin>;
  status?: Maybe<ChecklistItemStatus>;
};

export type ChecklistItemInput = {
  allowedDocuments?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  externalNotification?: InputMaybe<Scalars['Boolean']>;
  observation?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<ChecklistItemOrigin>;
  status?: InputMaybe<ChecklistItemStatus>;
};

export enum ChecklistItemOrigin {
  Caf = 'CAF',
  Collection = 'COLLECTION',
  UploadForm = 'UPLOAD_FORM'
}

export enum ChecklistItemStatus {
  Pending = 'PENDING',
  Sent = 'SENT',
  Valid = 'VALID'
}

export type City = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  state: State;
};

export enum ClientCategory {
  Other = 'OTHER',
  Prime = 'PRIME',
  SuperPrime = 'SUPER_PRIME'
}

export type Collection = {
  date?: Maybe<Scalars['DateTime']>;
  resultAsJson?: Maybe<Scalars['String']>;
};

export enum CollectionSource {
  BigboostCompanyAddress = 'BIGBOOST_COMPANY_ADDRESS',
  BigboostCompanyBasicData = 'BIGBOOST_COMPANY_BASIC_DATA',
  BigboostCompanyCompliance = 'BIGBOOST_COMPANY_COMPLIANCE',
  BigboostCompanyLawsuits = 'BIGBOOST_COMPANY_LAWSUITS',
  BigboostCompanyRelationships = 'BIGBOOST_COMPANY_RELATIONSHIPS',
  BigboostNegativeCertificate = 'BIGBOOST_NEGATIVE_CERTIFICATE',
  BigboostPersonCompliance = 'BIGBOOST_PERSON_COMPLIANCE',
  BigboostPersonLawsuits = 'BIGBOOST_PERSON_LAWSUITS',
  BigidQuiz = 'BIGID_QUIZ',
  BigGuysScore = 'BIG_GUYS_SCORE',
  Bizu_2 = 'BIZU_2',
  Bizu_3 = 'BIZU_3',
  BizuMatrix = 'BIZU_MATRIX',
  Boavista = 'BOAVISTA',
  Caf = 'CAF',
  CercReceivables = 'CERC_RECEIVABLES',
  CertificateLaborDebts = 'CERTIFICATE_LABOR_DEBTS',
  CertificateOfRegularity = 'CERTIFICATE_OF_REGULARITY',
  CertificateTributaryCredit = 'CERTIFICATE_TRIBUTARY_CREDIT',
  ClearSale = 'CLEAR_SALE',
  Crednet = 'CREDNET',
  CrednetBasic = 'CREDNET_BASIC',
  CrednetPartner = 'CREDNET_PARTNER',
  CrednetProtest = 'CREDNET_PROTEST',
  EmailAge = 'EMAIL_AGE',
  IpStack = 'IP_STACK',
  Neoway = 'NEOWAY',
  Neoway_2 = 'NEOWAY_2',
  NeuroId = 'NEURO_ID',
  RenewalScore_3 = 'RENEWAL_SCORE_3',
  ScoreSerasa_6_6M = 'SCORE_SERASA_6_6_M',
  Scr = 'SCR',
  Serasa = 'SERASA',
  SerasaBasicReport = 'SERASA_BASIC_REPORT',
  SerasaBasicReportScoreless = 'SERASA_BASIC_REPORT_SCORELESS',
  SerasaPartnerReport = 'SERASA_PARTNER_REPORT',
  SerasaPartnerReportScoreless = 'SERASA_PARTNER_REPORT_SCORELESS',
  SerasaScoreless = 'SERASA_SCORELESS',
  WorthyCredit = 'WORTHY_CREDIT'
}

export type CompanyInfo = {
  borrower?: Maybe<Borrower>;
  checklist?: Maybe<Checklist>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditAnalyst?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  id?: Maybe<Scalars['ID']>;
  isBizAccount?: Maybe<Scalars['Boolean']>;
  isChecklistCompleted?: Maybe<Scalars['Boolean']>;
  isChecklistUploadCompleted?: Maybe<Scalars['Boolean']>;
  lastCreditAnalysis?: Maybe<CreditAnalysis>;
  lastLegacyCreditWorthiness?: Maybe<LegacyCreditWorthiness>;
  legacyloanApplication?: Maybe<LegacyLoanApplication>;
  loanApplicationRef?: Maybe<LoanApplicationRef>;
  majorSigner?: Maybe<Signer>;
  product?: Maybe<LegacyProduct>;
  signers?: Maybe<Array<Maybe<Signer>>>;
};

export type CompanyInfoPagination = {
  currentPage: Scalars['Int'];
  pageSize: Scalars['Int'];
  records?: Maybe<Array<Maybe<CompanyInfo>>>;
  total: Scalars['Int'];
};

export type CompanyInfoSpecInput = {
  companyDocument?: InputMaybe<Scalars['String']>;
  creditAnalystUserName?: InputMaybe<Scalars['String']>;
  currentPage: Scalars['Int'];
  lastCreditAnalysisStatus?: InputMaybe<CreditAnalysisStatus>;
  pageSize: Scalars['Int'];
  productBizId?: InputMaybe<Scalars['String']>;
};

export enum ContentType {
  Date = 'DATE',
  DateMonthYear = 'DATE_MONTH_YEAR',
  Money = 'MONEY',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type CreditAnalysis = {
  creditOpinions?: Maybe<Array<Maybe<CreditOpinion>>>;
  id?: Maybe<Scalars['ID']>;
  invalidQuestionsMap?: Maybe<Array<Maybe<InvalidQuestionsCount>>>;
  questionnaire?: Maybe<Array<Maybe<Question>>>;
  relatedPeople?: Maybe<Array<Maybe<RelatedPerson>>>;
  status?: Maybe<CreditAnalysisStatus>;
};

export type CreditAnalysisInput = {
  creditOpinions?: InputMaybe<Array<InputMaybe<CreditOpinionInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  questionnaire?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  relatedPeople?: InputMaybe<Array<InputMaybe<RelatedPersonInput>>>;
  status?: InputMaybe<CreditAnalysisStatus>;
};

export enum CreditAnalysisStatus {
  Approved = 'APPROVED',
  CreditInvestigation = 'CREDIT_INVESTIGATION',
  FirstAuthority = 'FIRST_AUTHORITY',
  PreAuthority = 'PRE_AUTHORITY',
  Replaced = 'REPLACED',
  Repproved = 'REPPROVED',
  SecondAuthority = 'SECOND_AUTHORITY',
  ThirdAuthority = 'THIRD_AUTHORITY'
}

export type CreditAnalyst = {
  authorityLimits?: Maybe<Array<Maybe<CreditAnalystAuthorityLimits>>>;
  id?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export type CreditAnalystAuthorityLimits = {
  amountLimmitAprovation?: Maybe<Scalars['Int']>;
  authorityLevel?: Maybe<AuthorityLevel>;
};

export type CreditAnalystAuthorityLimitsInput = {
  amountLimmitAprovation?: InputMaybe<Scalars['Int']>;
  authorityLevel?: InputMaybe<AuthorityLevel>;
};

export type CreditAnalystInput = {
  authorityLimits?: InputMaybe<Array<InputMaybe<CreditAnalystAuthorityLimitsInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type CreditOpinion = {
  authorityLevel?: Maybe<AuthorityLevel>;
  changes?: Maybe<Array<Maybe<ChangeTracker>>>;
  comments?: Maybe<Scalars['String']>;
  creditOpinionSuggestionType?: Maybe<SuggestionType>;
  id?: Maybe<Scalars['ID']>;
  isAutomatic?: Maybe<Scalars['Boolean']>;
  lastChange?: Maybe<ChangeTracker>;
  newAmount?: Maybe<Scalars['Decimal']>;
  newInterestRate?: Maybe<Scalars['Decimal']>;
  newTenure?: Maybe<Scalars['Int']>;
  selectedMotives?: Maybe<Array<Maybe<PredefinedMotive>>>;
  status?: Maybe<CreditOpinionStatus>;
  trustLevel?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

export type CreditOpinionInput = {
  authorityLevel?: InputMaybe<AuthorityLevel>;
  changes?: InputMaybe<Array<InputMaybe<ChangeTrackerInput>>>;
  comments?: InputMaybe<Scalars['String']>;
  creditOpinionSuggestionType?: InputMaybe<SuggestionType>;
  id?: InputMaybe<Scalars['ID']>;
  isAutomatic?: InputMaybe<Scalars['Boolean']>;
  newAmount?: InputMaybe<Scalars['Decimal']>;
  newInterestRate?: InputMaybe<Scalars['Decimal']>;
  newTenure?: InputMaybe<Scalars['Int']>;
  selectedMotives?: InputMaybe<Array<InputMaybe<PredefinedMotiveInput>>>;
  status?: InputMaybe<CreditOpinionStatus>;
  trustLevel?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
};

export enum CreditOpinionStatus {
  Discarded = 'DISCARDED',
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED'
}

export type Credit_LegacyRelationship = {
  clientId?: Maybe<Scalars['Int']>;
  documentId?: Maybe<Scalars['Int']>;
  signerId?: Maybe<Scalars['Int']>;
};

export type Document = {
  discardedDate?: Maybe<Scalars['DateTime']>;
  documentDate?: Maybe<Scalars['Date']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  insertedBy?: Maybe<Scalars['String']>;
  isDiscarded?: Maybe<Scalars['Boolean']>;
  isOnTempBucket?: Maybe<Scalars['Boolean']>;
  legacyRelationship?: Maybe<Credit_LegacyRelationship>;
  origin?: Maybe<DocumentOrigin>;
  type?: Maybe<DocumentType>;
  updatedAt?: Maybe<Scalars['Date']>;
  url?: Maybe<Scalars['String']>;
  urn?: Maybe<Scalars['String']>;
};

export enum DocumentOrigin {
  ThirdPart = 'THIRD_PART',
  UploadedByAnalyst = 'UPLOADED_BY_ANALYST',
  UploadedByUser = 'UPLOADED_BY_USER'
}

export enum DocumentType {
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  CompanyBankStatement = 'COMPANY_BANK_STATEMENT',
  CompanyCnpjRegularity = 'COMPANY_CNPJ_REGULARITY',
  CompanyMateriality = 'COMPANY_MATERIALITY',
  CompanyProofOfAddress = 'COMPANY_PROOF_OF_ADDRESS',
  ConfirmationAudio = 'CONFIRMATION_AUDIO',
  DeathCertificate = 'DEATH_CERTIFICATE',
  DownPaymentReceipt = 'DOWN_PAYMENT_RECEIPT',
  FgtsRegularityCertificate = 'FGTS_REGULARITY_CERTIFICATE',
  IndividualEntrepreneurCertificate = 'INDIVIDUAL_ENTREPRENEUR_CERTIFICATE',
  Invoice = 'INVOICE',
  LaborMinistryRegularityCertificate = 'LABOR_MINISTRY_REGULARITY_CERTIFICATE',
  MicroBusinessesCertificate = 'MICRO_BUSINESSES_CERTIFICATE',
  PartnerBankStatement = 'PARTNER_BANK_STATEMENT',
  PartnerCpf = 'PARTNER_CPF',
  PartnerCpfRegularity = 'PARTNER_CPF_REGULARITY',
  PartnerDriverLicence = 'PARTNER_DRIVER_LICENCE',
  PartnerDriverLicenceVerse = 'PARTNER_DRIVER_LICENCE_VERSE',
  PartnerIdentity = 'PARTNER_IDENTITY',
  PartnerIdentityVerse = 'PARTNER_IDENTITY_VERSE',
  PartnerIncomeStatement = 'PARTNER_INCOME_STATEMENT',
  PartnerIncomeTaxReturn = 'PARTNER_INCOME_TAX_RETURN',
  PartnerMarriageCertificate = 'PARTNER_MARRIAGE_CERTIFICATE',
  PartnerProofOfAddress = 'PARTNER_PROOF_OF_ADDRESS',
  PartnerProofOfIncome = 'PARTNER_PROOF_OF_INCOME',
  PartnerSelfie = 'PARTNER_SELFIE',
  PgfnRegularityCertificate = 'PGFN_REGULARITY_CERTIFICATE',
  PartnerDigitalDriverLicense = 'PARTNER_DIGITAL_DRIVER_LICENSE',
  Unknown = 'UNKNOWN'
}

export type DocumentUploadS3 = {
  data?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  gcsUploadUrl?: Maybe<Scalars['String']>;
  gcsDocumentId?: Maybe<Scalars['String']>;
};

export enum Gender {
  F = 'F',
  M = 'M'
}

export type InvalidApplicant = {
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<InvalidApplicantReason>;
};

export enum InvalidApplicantReason {
  AlreadyExists = 'ALREADY_EXISTS',
  InvalidDocument = 'INVALID_DOCUMENT',
  NotFound = 'NOT_FOUND'
}

export type InvalidQuestionsCount = {
  key?: Maybe<QuestionnaireType>;
  value?: Maybe<Scalars['Int']>;
};

export type LegacyBizu = {
  bizuIndicator?: Maybe<Scalars['String']>;
  bizuScore?: Maybe<Scalars['Float']>;
  bizuVersion?: Maybe<Scalars['Int']>;
  probability?: Maybe<Scalars['Float']>;
};

export type LegacyChecklistScore = {
  probability?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Int']>;
};

export type LegacyClearSaleData = {
  document?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  referenceDate?: Maybe<Scalars['DateTime']>;
  results?: Maybe<LegacyClearSaleResults>;
  transactionId?: Maybe<Scalars['String']>;
  verifiedPhone?: Maybe<Scalars['Boolean']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type LegacyClearSaleInsight = {
  category?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  relatedTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  relevance?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LegacyClearSaleRating = {
  date?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<Scalars['String']>;
  relatedTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['Int']>;
};

export type LegacyClearSaleResults = {
  insights?: Maybe<Array<Maybe<LegacyClearSaleInsight>>>;
  ratings?: Maybe<Array<Maybe<LegacyClearSaleRating>>>;
  score?: Maybe<LegacyClearSaleScore>;
};

export type LegacyClearSaleScore = {
  date?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type LegacyCreditWorthiness = {
  bigGuysScore?: Maybe<Scalars['String']>;
  bizu?: Maybe<LegacyBizu>;
  bizu3?: Maybe<LegacyBizu>;
  bizuComboZoneNumber?: Maybe<Scalars['Int']>;
  checklistScore?: Maybe<LegacyChecklistScore>;
  clearSale?: Maybe<LegacyClearSaleData>;
  clientCategory?: Maybe<ClientCategory>;
  loanApplicationId?: Maybe<Scalars['ID']>;
  probability?: Maybe<Scalars['Float']>;
  processingEnd?: Maybe<Scalars['DateTime']>;
  processingStart?: Maybe<Scalars['DateTime']>;
  psychometricScore?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  serasa?: Maybe<LegacySerasa>;
  statementScore?: Maybe<LegacyStatementScore>;
  statementScoreBigGuys?: Maybe<LegacyStatementScoreBigGuys>;
};

export type LegacyLoanApplication = {
  acceptedProposal?: Maybe<LegacyProposal>;
  alienatedItems?: Maybe<Array<Maybe<AlienatedItem>>>;
  amountRequested?: Maybe<Scalars['Decimal']>;
  approvedProposal?: Maybe<LegacyProposal>;
  creditAnalyst?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  documentsAnalyst?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  insideSalesAnalyst?: Maybe<Scalars['String']>;
  lastProposal?: Maybe<LegacyProposal>;
  legacyRelationship?: Maybe<Loan_LegacyRelationship>;
  optInIp?: Maybe<Scalars['String']>;
  proposals?: Maybe<Array<Maybe<LegacyProposal>>>;
  reasonDetail?: Maybe<Scalars['String']>;
  reasonValue?: Maybe<Scalars['String']>;
  renewalInformation?: Maybe<LegacyRenewalInformation>;
  status?: Maybe<LoanApplicationStatus>;
  utmSource?: Maybe<Scalars['String']>;
};

export type LegacyProduct = {
  bizId?: Maybe<Scalars['String']>;
  maxAmountToRequest?: Maybe<Scalars['Decimal']>;
  maxNumberOfInstallments?: Maybe<Scalars['Int']>;
  maxNumberOfInstallmentsForWeeklyInterval?: Maybe<Scalars['Int']>;
  minAmountToRequest?: Maybe<Scalars['Decimal']>;
  minInterestRate?: Maybe<Scalars['Decimal']>;
  minNumberOfInstallments?: Maybe<Scalars['Int']>;
  minNumberOfInstallmentsForWeeklyInterval?: Maybe<Scalars['Int']>;
  paymentInterval?: Maybe<PaymentInterval>;
};

export type LegacyProposal = {
  amount?: Maybe<Scalars['Decimal']>;
  commission?: Maybe<Scalars['Decimal']>;
  date: Scalars['DateTime'];
  downPayments?: Maybe<Scalars['Int']>;
  fixedComission?: Maybe<Scalars['Boolean']>;
  interestRate?: Maybe<Scalars['Decimal']>;
  paymentDay?: Maybe<Scalars['DateTime']>;
  paymentInterval?: Maybe<PaymentInterval>;
  tenure?: Maybe<Scalars['Int']>;
};

export type LegacyRelationshipInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  signerId?: InputMaybe<Scalars['Int']>;
};

export type LegacyRenewalInformation = {
  previousLoans?: Maybe<Array<Maybe<Scalars['ID']>>>;
  previousLoansCount?: Maybe<Scalars['Int']>;
};

export type LegacySerasa = {
  serasaScore?: Maybe<Scalars['Float']>;
  serasaVersion?: Maybe<Scalars['Int']>;
};

export type LegacyStatementScore = {
  indicator?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  probability?: Maybe<Scalars['Float']>;
};

export type LegacyStatementScoreBigGuys = {
  indicator?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  probability?: Maybe<Scalars['Float']>;
};

export type Liveness = {
  sharedUrl?: Maybe<LivenessSharedUrl>;
  status?: Maybe<LivenessStatus>;
};

export type LivenessSharedUrl = {
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export enum LivenessStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  PendingOcr = 'PENDING_OCR',
  Proccessing = 'PROCCESSING',
  Reproved = 'REPROVED',
  Unknown = 'UNKNOWN'
}

export type LoanAccountability = {
  documents?: Maybe<Array<Maybe<AccountabilityDocument>>>;
  id?: Maybe<Scalars['ID']>;
};

export type LoanAccountabilityInput = {
  documents?: InputMaybe<Array<InputMaybe<AccountabilityDocumentInput>>>;
  id?: InputMaybe<Scalars['ID']>;
};

export type LoanApplicationRef = {
  id?: Maybe<Scalars['ID']>;
};

export enum LoanApplicationStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Closure = 'CLOSURE',
  Denied = 'DENIED',
  DocumentsPending = 'DOCUMENTS_PENDING',
  DocumentsReceived = 'DOCUMENTS_RECEIVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  InAnalysis = 'IN_ANALYSIS',
  Lost = 'LOST',
  Outsourced = 'OUTSOURCED',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  RenewalAnalysis = 'RENEWAL_ANALYSIS',
  SignaturePending = 'SIGNATURE_PENDING'
}

export type Loan_LegacyRelationship = {
  clientId?: Maybe<Scalars['ID']>;
  leadId?: Maybe<Scalars['ID']>;
  loanRequestId?: Maybe<Scalars['ID']>;
  offerId?: Maybe<Scalars['ID']>;
};

export enum MaritalStatus {
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Separated = 'SEPARATED',
  Single = 'SINGLE',
  StableUnion = 'STABLE_UNION',
  Widowed = 'WIDOWED'
}

export type Mutation = {
  adjustCompanyInfoChecklistForProduct?: Maybe<CompanyInfo>;
  backToPreviousCreditOpinion?: Maybe<CreditAnalysis>;
  buildChecklist?: Maybe<CompanyInfo>;
  callAutomations?: Maybe<Scalars['Boolean']>;
  callbackCreditAutomations?: Maybe<Scalars['Boolean']>;
  completeChecklistItem?: Maybe<CompanyInfo>;
  completeSignerChecklistItem?: Maybe<CompanyInfo>;
  createAntifraudForLoanApplication?: Maybe<AntiFraud>;
  createBooleanQuestion?: Maybe<Question>;
  createCompanyInfo?: Maybe<CompanyInfo>;
  createPreQualifiedLoan?: Maybe<PreQualifiedLoan>;
  deleteCreditAnalyst?: Maybe<Scalars['ID']>;
  deleteCreditOpinion?: Maybe<CreditAnalysis>;
  deleteDocument?: Maybe<CompanyInfo>;
  deletePredefinedMotive?: Maybe<Scalars['ID']>;
  deleteQuestion?: Maybe<Scalars['ID']>;
  deleteRelatedPerson?: Maybe<RelatedPerson>;
  deleteSigner?: Maybe<CompanyInfo>;
  finishUserLivenessOnboarding?: Maybe<Liveness>;
  finishWorthyCreditForm?: Maybe<WorthyCredit>;
  generateCompanyDocumentToUploadAsync?: Maybe<DocumentUploadS3>;
  generateSharedUrl?: Maybe<LivenessSharedUrl>;
  generateSignerDocumentToUploadAsync?: Maybe<DocumentUploadS3>;
  generateWorthyCreditForm?: Maybe<WorthyCredit>;
  insertRelatedPerson?: Maybe<RelatedPerson>;
  manuallyQualifyDocument?: Maybe<CompanyInfo>;
  replaceLastCreditOpinion?: Maybe<CreditAnalysis>;
  requestCreditOpinionReview?: Maybe<CreditAnalysis>;
  requestSyncQualificationResult?: Maybe<Scalars['Boolean']>;
  requestWorthyCredit?: Maybe<AntiFraud>;
  resetQuestionnaire?: Maybe<CreditAnalysis>;
  saveCreditAnalyst?: Maybe<CreditAnalyst>;
  savePredefinedMotive?: Maybe<PredefinedMotive>;
  saveQuestion?: Maybe<Question>;
  sendBackToFirstAuthority?: Maybe<CreditAnalysis>;
  sendBackToPreAuthority?: Maybe<CreditAnalysis>;
  sendToAuthority?: Maybe<CreditAnalysis>;
  setAntiFraudApplicantForLoanApplication?: Maybe<ApplicantResultType>;
  setAsCreditInvestigation?: Maybe<CreditAnalysis>;
  setCompanyInfoLegacyRelationship?: Maybe<CompanyInfo>;
  setCreditAnalyst?: Maybe<CompanyInfo>;
  startCreditAnalysis?: Maybe<CompanyInfo>;
  submitCreditOpinion?: Maybe<CreditAnalysis>;
  unsetCreditAnalyst?: Maybe<CompanyInfo>;
  updateCompanyInfoAddress?: Maybe<CompanyInfo>;
  updateCompanyInfoBankAccount?: Maybe<CompanyInfo>;
  updateCompanyInfoChecklist?: Maybe<CompanyInfo>;
  updateCreditAnalysisChecklist?: Maybe<CreditAnalysis>;
  updateCreditAnalysisOpinion?: Maybe<CreditAnalysis>;
  updateLoanAccountability?: Maybe<LoanAccountability>;
  updateRelatedPersonQuestionnaire?: Maybe<RelatedPerson>;
  updateSignerChecklist?: Maybe<Signer>;
  uploadLoanAccountabilityDoc?: Maybe<LoanAccountability>;
  uploadPreQualifiedProposalDoc?: Maybe<Scalars['String']>;
  upsertSigner?: Maybe<Signer>;
};


export type MutationAdjustCompanyInfoChecklistForProductArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationBackToPreviousCreditOpinionArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  creditOpinionInput: CreditOpinionInput;
};


export type MutationBuildChecklistArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationCallAutomationsArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
};


export type MutationCallbackCreditAutomationsArgs = {
  automaticAuthorityDecisionInput: AutomaticAuthorityDecisionInput;
};


export type MutationCompleteChecklistItemArgs = {
  documentType: DocumentType;
  loanApplicationId: Scalars['ID'];
};


export type MutationCompleteSignerChecklistItemArgs = {
  documentType: DocumentType;
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
};


export type MutationCreateAntifraudForLoanApplicationArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationCreateBooleanQuestionArgs = {
  asking: Scalars['String'];
  noWeight: Scalars['Float'];
  questionnaireType: QuestionnaireType;
  required: Scalars['Boolean'];
  yesWeight: Scalars['Float'];
};


export type MutationCreateCompanyInfoArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationCreatePreQualifiedLoanArgs = {
  preQualifiedLoanInput: PreQualifiedLoanInput;
};


export type MutationDeleteCreditAnalystArgs = {
  creditAnalystInput: CreditAnalystInput;
};


export type MutationDeleteCreditOpinionArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  creditOpinionInput: CreditOpinionInput;
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID'];
  loanApplicationId: Scalars['ID'];
  ownerId: Scalars['ID'];
};


export type MutationDeletePredefinedMotiveArgs = {
  predefinedMotiveInput: PredefinedMotiveInput;
};


export type MutationDeleteQuestionArgs = {
  questionInput: QuestionInput;
};


export type MutationDeleteRelatedPersonArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  relatedPersonDocument: Scalars['String'];
};


export type MutationDeleteSignerArgs = {
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
};


export type MutationFinishUserLivenessOnboardingArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationFinishWorthyCreditFormArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationGenerateCompanyDocumentToUploadAsyncArgs = {
  contentType: Scalars['String'];
  documentOrigin: DocumentOrigin;
  documentType: DocumentType;
  filename: Scalars['String'];
  insertUserEmail?: InputMaybe<Scalars['String']>;
  loanApplicationId: Scalars['ID'];
};


export type MutationGenerateSharedUrlArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationGenerateSignerDocumentToUploadAsyncArgs = {
  contentType: Scalars['String'];
  documentOrigin: DocumentOrigin;
  documentType: DocumentType;
  filename: Scalars['String'];
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
};


export type MutationGenerateWorthyCreditFormArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationInsertRelatedPersonArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  relatedPersonInput: RelatedPersonInput;
};


export type MutationManuallyQualifyDocumentArgs = {
  destinyId: Scalars['ID'];
  documentId: Scalars['ID'];
  documentType: DocumentType;
  loanApplicationId: Scalars['ID'];
  originId: Scalars['ID'];
};


export type MutationReplaceLastCreditOpinionArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
};


export type MutationRequestCreditOpinionReviewArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  creditOpinionInput: CreditOpinionInput;
};


export type MutationRequestSyncQualificationResultArgs = {
  loanApplicationId: Scalars['ID'];
  reprocess?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRequestWorthyCreditArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationResetQuestionnaireArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
};


export type MutationSaveCreditAnalystArgs = {
  creditAnalystInput: CreditAnalystInput;
};


export type MutationSavePredefinedMotiveArgs = {
  predefinedMotiveInput: PredefinedMotiveInput;
};


export type MutationSaveQuestionArgs = {
  questionInput: QuestionInput;
};


export type MutationSendBackToFirstAuthorityArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
};


export type MutationSendBackToPreAuthorityArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
};


export type MutationSendToAuthorityArgs = {
  companyInfoId: Scalars['ID'];
};


export type MutationSetAntiFraudApplicantForLoanApplicationArgs = {
  applicantInput: ApplicantInput;
};


export type MutationSetAsCreditInvestigationArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  creditOpinionInput: CreditOpinionInput;
};


export type MutationSetCompanyInfoLegacyRelationshipArgs = {
  legacyClientId: Scalars['Int'];
  loanApplicationId: Scalars['ID'];
};


export type MutationSetCreditAnalystArgs = {
  companyInfoId: Scalars['ID'];
};


export type MutationStartCreditAnalysisArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationSubmitCreditOpinionArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  creditOpinionInput: CreditOpinionInput;
};


export type MutationUnsetCreditAnalystArgs = {
  companyInfoId: Scalars['ID'];
  username: Scalars['String'];
};


export type MutationUpdateCompanyInfoAddressArgs = {
  addressInput: AddressInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateCompanyInfoBankAccountArgs = {
  bankAccountInput: BankAccountInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateCompanyInfoChecklistArgs = {
  checklistInput: ChecklistInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateCreditAnalysisChecklistArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisInput: CreditAnalysisInput;
};


export type MutationUpdateCreditAnalysisOpinionArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  creditOpinionInput: CreditOpinionInput;
};


export type MutationUpdateLoanAccountabilityArgs = {
  loanAccountabilityInput: LoanAccountabilityInput;
};


export type MutationUpdateRelatedPersonQuestionnaireArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
  relatedPersonInput: RelatedPersonInput;
};


export type MutationUpdateSignerChecklistArgs = {
  checklistInput: ChecklistInput;
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
};


export type MutationUploadLoanAccountabilityDocArgs = {
  base64Document: Scalars['String'];
  filename: Scalars['String'];
  loanApplicationId: Scalars['ID'];
};


export type MutationUploadPreQualifiedProposalDocArgs = {
  base64Document: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationUpsertSignerArgs = {
  loanApplicationId: Scalars['ID'];
  signerInput: SignerInput;
};

export enum Nationality {
  Brazilian = 'BRAZILIAN',
  Foreigner = 'FOREIGNER'
}

export enum PaymentInterval {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type PreQualifiedLoan = {
  amount?: Maybe<Scalars['Float']>;
  borrowerInfo?: Maybe<BorrowerInfo>;
  date?: Maybe<Scalars['Date']>;
  document?: Maybe<Scalars['String']>;
  hasReceivables?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  interestRate?: Maybe<Scalars['Float']>;
  isLowTicket?: Maybe<Scalars['Boolean']>;
  loanApplicationStatus?: Maybe<LoanApplicationStatus>;
  owner?: Maybe<PreQualifiedLoanOwner>;
  predefinedComissionPercent?: Maybe<Scalars['Float']>;
  status?: Maybe<PreQualifiedLoanStatus>;
  term?: Maybe<Scalars['Int']>;
};

export type PreQualifiedLoanInput = {
  amount?: InputMaybe<Scalars['Float']>;
  borrowerInfo?: InputMaybe<BorrowerInfoInput>;
  document?: InputMaybe<Scalars['String']>;
  hasReceivables?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  interestRate?: InputMaybe<Scalars['Float']>;
  isLowTicket?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<PreQualifiedLoanOwner>;
  predefinedComissionPercent?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<PreQualifiedLoanStatus>;
  term?: InputMaybe<Scalars['Int']>;
};

export enum PreQualifiedLoanOwner {
  Ambev = 'AMBEV',
  Magalu = 'MAGALU'
}

export enum PreQualifiedLoanStatus {
  Accepted = 'ACCEPTED',
  Awaiting = 'AWAITING',
  Denied = 'DENIED',
  Expired = 'EXPIRED'
}

export type PreQualifiedPagination = {
  currentPage: Scalars['Int'];
  pageSize: Scalars['Int'];
  records?: Maybe<Array<Maybe<PreQualifiedLoan>>>;
  total: Scalars['Int'];
};

export type PreQualifiedSpecificationInputType = {
  currentPage: Scalars['Int'];
  document?: InputMaybe<Scalars['String']>;
  pageSize: Scalars['Int'];
  preQualifiedStatus?: InputMaybe<PreQualifiedLoanStatus>;
};

export type PredefinedMotive = {
  id?: Maybe<Scalars['ID']>;
  internal?: Maybe<Scalars['Boolean']>;
  skipChecklist?: Maybe<Scalars['Boolean']>;
  suggestionType?: Maybe<SuggestionType>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PredefinedMotiveInput = {
  id?: InputMaybe<Scalars['ID']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  skipChecklist?: InputMaybe<Scalars['Boolean']>;
  suggestionType?: InputMaybe<SuggestionType>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Query = {
  accountabilityDocumentPreassignedUrl?: Maybe<Scalars['String']>;
  antiFraud?: Maybe<AntiFraud>;
  authoritiesByUsername?: Maybe<Array<Maybe<AuthorityLevel>>>;
  banks?: Maybe<Array<Maybe<Bank>>>;
  citiesByStateId?: Maybe<Array<Maybe<City>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  companyInfo?: Maybe<CompanyInfo>;
  companyInfoSigner?: Maybe<Signer>;
  companyInfoSigners?: Maybe<Array<Maybe<Signer>>>;
  companyInfos?: Maybe<CompanyInfoPagination>;
  creditAnalysts?: Maybe<Array<Maybe<CreditAnalyst>>>;
  getProducts?: Maybe<Array<Maybe<LegacyProduct>>>;
  isProcessingCreditAutomation?: Maybe<AutomaticAuthorityDecisionCache>;
  latestPreQualifiedLoan?: Maybe<PreQualifiedLoan>;
  loanAccountability?: Maybe<LoanAccountability>;
  preQualifiedLoan?: Maybe<PreQualifiedLoan>;
  preQualifiedLoansByDocument?: Maybe<Array<Maybe<PreQualifiedLoan>>>;
  preQualifiedProposalDocumentPreAssignedUrl?: Maybe<Scalars['String']>;
  preQualifiedProposalMessageCountInQueue?: Maybe<Scalars['Int']>;
  preQualifiedProposals?: Maybe<PreQualifiedPagination>;
  predefinedMotives?: Maybe<Array<Maybe<PredefinedMotive>>>;
  questionsFromTemplate?: Maybe<Array<Maybe<Question>>>;
  states?: Maybe<Array<Maybe<State>>>;
};


export type QueryAccountabilityDocumentPreassignedUrlArgs = {
  fileName: Scalars['String'];
  loanAccountabilityId: Scalars['ID'];
};


export type QueryAntiFraudArgs = {
  loanApplicationId: Scalars['ID'];
};


export type QueryAuthoritiesByUsernameArgs = {
  username: Scalars['String'];
};


export type QueryCitiesByStateIdArgs = {
  stateId: Scalars['ID'];
};


export type QueryCollectionsArgs = {
  loanApplicationId: Scalars['ID'];
  source: CollectionSource;
};


export type QueryCompanyInfoArgs = {
  loanApplicationId: Scalars['ID'];
};


export type QueryCompanyInfoSignerArgs = {
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
};


export type QueryCompanyInfoSignersArgs = {
  loanApplicationId: Scalars['ID'];
};


export type QueryCompanyInfosArgs = {
  queryParams: CompanyInfoSpecInput;
};


export type QueryIsProcessingCreditAutomationArgs = {
  companyInfoId: Scalars['ID'];
  creditAnalysisId: Scalars['ID'];
};


export type QueryLatestPreQualifiedLoanArgs = {
  owner: PreQualifiedLoanOwner;
  preQualifiedLoanId: Scalars['ID'];
};


export type QueryLoanAccountabilityArgs = {
  loanApplicationId: Scalars['ID'];
};


export type QueryPreQualifiedLoanArgs = {
  id: Scalars['ID'];
};


export type QueryPreQualifiedLoansByDocumentArgs = {
  document: Scalars['String'];
};


export type QueryPreQualifiedProposalsArgs = {
  queryParams: PreQualifiedSpecificationInputType;
};


export type QueryPredefinedMotivesArgs = {
  suggestionType?: InputMaybe<SuggestionType>;
};


export type QueryQuestionsFromTemplateArgs = {
  questionnaireType?: InputMaybe<QuestionnaireType>;
};

export type Question = {
  answers?: Maybe<Array<Maybe<Answer>>>;
  asking?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  order?: Maybe<Scalars['Int']>;
  questionnaireType?: Maybe<QuestionnaireType>;
  required?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
};

export type QuestionInput = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  asking: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
  questionnaireType?: InputMaybe<QuestionnaireType>;
  required?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export enum QuestionnaireType {
  Complexity = 'COMPLEXITY',
  Financial = 'FINANCIAL',
  HiddenPartner = 'HIDDEN_PARTNER',
  HiddenRelatedCompany = 'HIDDEN_RELATED_COMPANY',
  Identity = 'IDENTITY',
  MajorityPartner = 'MAJORITY_PARTNER',
  Materiality = 'MATERIALITY'
}

export type RelatedPerson = {
  documentNumber?: Maybe<Scalars['String']>;
  questionnaire?: Maybe<Array<Maybe<Question>>>;
  type?: Maybe<RelatedPersonType>;
};

export type RelatedPersonInput = {
  documentNumber?: InputMaybe<Scalars['String']>;
  questionnaire?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  type?: InputMaybe<RelatedPersonType>;
};

export enum RelatedPersonType {
  ConcealedPartner = 'CONCEALED_PARTNER',
  ConcealedRelated = 'CONCEALED_RELATED',
  DirectlyRelated = 'DIRECTLY_RELATED',
  DirectPartner = 'DIRECT_PARTNER',
  Drawee = 'DRAWEE',
  NonPartnerRelated = 'NON_PARTNER_RELATED',
  PossiblePartner = 'POSSIBLE_PARTNER',
  PossiblyRelated = 'POSSIBLY_RELATED'
}

export type Signer = {
  address?: Maybe<Address>;
  administrator?: Maybe<Scalars['Boolean']>;
  birthDay?: Maybe<Scalars['Date']>;
  birthPlace?: Maybe<Scalars['String']>;
  checklist?: Maybe<Checklist>;
  documentNumber?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  guarantor?: Maybe<Scalars['Boolean']>;
  hiddenDocument?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  identityIssuingBody?: Maybe<Scalars['String']>;
  identityIssuingBodyUf?: Maybe<Scalars['String']>;
  identityNumber?: Maybe<Scalars['String']>;
  legacyRelationship?: Maybe<Credit_LegacyRelationship>;
  legalRepresentative?: Maybe<Scalars['Boolean']>;
  maritalStatus?: Maybe<MaritalStatus>;
  name?: Maybe<Scalars['String']>;
  nationalRegistryOfForeigners?: Maybe<Scalars['String']>;
  nationality?: Maybe<Nationality>;
  profession?: Maybe<Scalars['String']>;
  revenue?: Maybe<Scalars['Decimal']>;
  shareHolder?: Maybe<Scalars['Boolean']>;
  sharePercentage?: Maybe<Scalars['Decimal']>;
  spouse?: Maybe<Spouse>;
};

export type SignerInput = {
  address?: InputMaybe<AddressInput>;
  administrator?: InputMaybe<Scalars['Boolean']>;
  birthDay?: InputMaybe<Scalars['Date']>;
  birthPlace?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  guarantor?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  identityIssuingBody?: InputMaybe<Scalars['String']>;
  identityIssuingBodyUf?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  legacyRelationship?: InputMaybe<LegacyRelationshipInput>;
  legalRepresentative?: InputMaybe<Scalars['Boolean']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  name?: InputMaybe<Scalars['String']>;
  nationalRegistryOfForeigners?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Nationality>;
  profession?: InputMaybe<Scalars['String']>;
  revenue?: InputMaybe<Scalars['Decimal']>;
  shareHolder?: InputMaybe<Scalars['Boolean']>;
  sharePercentage?: InputMaybe<Scalars['Decimal']>;
  spouse?: InputMaybe<SpouseInput>;
};

export type Spouse = {
  documentNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  signer?: Maybe<Scalars['Boolean']>;
};

export type SpouseInput = {
  documentNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  signer?: InputMaybe<Scalars['Boolean']>;
};

export type State = {
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export enum SuggestionType {
  Approve = 'APPROVE',
  ApproveWithChanges = 'APPROVE_WITH_CHANGES',
  Reprove = 'REPROVE'
}

export type WorthyCredit = {
  candidateId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  questionnaireUrl?: Maybe<Scalars['String']>;
  results?: Maybe<WorthyCreditResults>;
  status?: Maybe<WorthyCreditStatus>;
};

export type WorthyCreditResults = {
  candidateComplete?: Maybe<Scalars['Boolean']>;
  imPass?: Maybe<Scalars['Boolean']>;
  overallPass?: Maybe<Scalars['Int']>;
  overallScore?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export enum WorthyCreditStatus {
  Answered = 'ANSWERED',
  Draft = 'DRAFT',
  Generated = 'GENERATED',
  Processed = 'PROCESSED'
}

export type SetAntiFraudApplicantForLoanApplicationMutationVariables = Exact<{
  applicantInput: ApplicantInput;
}>;


export type SetAntiFraudApplicantForLoanApplicationMutation = { __typename: 'Mutation', setAntiFraudApplicantForLoanApplication?: { __typename: 'Applicant', relationship?: ApplicantRelationship | null | undefined } | { __typename: 'InvalidApplicant', message?: string | null | undefined, reason?: InvalidApplicantReason | null | undefined } | null | undefined };

export type CreateCompanyInfoMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type CreateCompanyInfoMutation = { __typename: 'Mutation', createCompanyInfo?: { __typename: 'CompanyInfo', id?: string | null | undefined } | null | undefined };

export type BuildChecklistMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type BuildChecklistMutation = { __typename: 'Mutation', buildChecklist?: { __typename: 'CompanyInfo', id?: string | null | undefined } | null | undefined };

export type CompleteChecklistItemMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  documentType: DocumentType;
}>;


export type CompleteChecklistItemMutation = { __typename: 'Mutation', completeChecklistItem?: { __typename: 'CompanyInfo', id?: string | null | undefined, checklist?: { __typename: 'Checklist', items?: Array<{ __typename: 'ChecklistItem', allowedDocuments?: Array<DocumentType | null | undefined> | null | undefined, status?: ChecklistItemStatus | null | undefined, origin?: ChecklistItemOrigin | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type CompleteSignerChecklistItemMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
  documentType: DocumentType;
}>;


export type CompleteSignerChecklistItemMutation = { __typename: 'Mutation', completeSignerChecklistItem?: { __typename: 'CompanyInfo', id?: string | null | undefined, checklist?: { __typename: 'Checklist', items?: Array<{ __typename: 'ChecklistItem', allowedDocuments?: Array<DocumentType | null | undefined> | null | undefined, status?: ChecklistItemStatus | null | undefined, origin?: ChecklistItemOrigin | null | undefined } | null | undefined> | null | undefined } | null | undefined, signers?: Array<{ __typename: 'Signer', checklist?: { __typename: 'Checklist', items?: Array<{ __typename: 'ChecklistItem', allowedDocuments?: Array<DocumentType | null | undefined> | null | undefined, status?: ChecklistItemStatus | null | undefined, origin?: ChecklistItemOrigin | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GenerateSignerDocumentToUploadAsyncMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
  documentType: DocumentType;
  documentOrigin: DocumentOrigin;
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateSignerDocumentToUploadAsyncMutation = { __typename: 'Mutation', generateSignerDocumentToUploadAsync?: { __typename: 'DocumentUploadS3', data?: string | null | undefined, url?: string | null | undefined, gcsUploadUrl?: string | null | undefined, gcsDocumentId?: string | null | undefined } | null | undefined };

export type GenerateCompanyDocumentToUploadAsyncMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  documentType: DocumentType;
  documentOrigin: DocumentOrigin;
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateCompanyDocumentToUploadAsyncMutation = { __typename: 'Mutation', generateCompanyDocumentToUploadAsync?: { __typename: 'DocumentUploadS3', data?: string | null | undefined, url?: string | null | undefined, gcsUploadUrl?: string | null | undefined, gcsDocumentId?: string | null | undefined } | null | undefined };

export type GenerateWorthyCreditFormMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type GenerateWorthyCreditFormMutation = { __typename: 'Mutation', generateWorthyCreditForm?: { __typename: 'WorthyCredit', questionnaireUrl?: string | null | undefined } | null | undefined };

export type FinishWorthyCreditFormMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type FinishWorthyCreditFormMutation = { __typename: 'Mutation', finishWorthyCreditForm?: { __typename: 'WorthyCredit', questionnaireUrl?: string | null | undefined, status?: WorthyCreditStatus | null | undefined } | null | undefined };

export type CompanyInfoCheckListQueryVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type CompanyInfoCheckListQuery = { __typename: 'Query', companyInfo?: { __typename: 'CompanyInfo', id?: string | null | undefined, isChecklistCompleted?: boolean | null | undefined, isChecklistUploadCompleted?: boolean | null | undefined, checklist?: { __typename: 'Checklist', isCompleted?: boolean | null | undefined, items?: Array<{ __typename: 'ChecklistItem', allowedDocuments?: Array<DocumentType | null | undefined> | null | undefined, status?: ChecklistItemStatus | null | undefined, origin?: ChecklistItemOrigin | null | undefined, observation?: string | null | undefined, externalNotification?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined, signers?: Array<{ __typename: 'Signer', id?: string | null | undefined, documentNumber?: string | null | undefined, name?: string | null | undefined, checklist?: { __typename: 'Checklist', isCompleted?: boolean | null | undefined, items?: Array<{ __typename: 'ChecklistItem', allowedDocuments?: Array<DocumentType | null | undefined> | null | undefined, status?: ChecklistItemStatus | null | undefined, origin?: ChecklistItemOrigin | null | undefined, observation?: string | null | undefined, externalNotification?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CompanyInfoSignerQueryVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  signerId: Scalars['ID'];
}>;


export type CompanyInfoSignerQuery = { __typename: 'Query', companyInfoSigner?: { __typename: 'Signer', name?: string | null | undefined, hiddenDocument?: string | null | undefined } | null | undefined };

export type CompanyInfoQueryVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type CompanyInfoQuery = { __typename: 'Query', companyInfo?: { __typename: 'CompanyInfo', id?: string | null | undefined } | null | undefined };


export const SetAntiFraudApplicantForLoanApplicationDocument = gql`
    mutation setAntiFraudApplicantForLoanApplication($applicantInput: ApplicantInput!) {
  setAntiFraudApplicantForLoanApplication(applicantInput: $applicantInput) {
    ... on Applicant {
      relationship
    }
    ... on InvalidApplicant {
      message
      reason
    }
  }
}
    `;
export type SetAntiFraudApplicantForLoanApplicationMutationFn = Apollo.MutationFunction<SetAntiFraudApplicantForLoanApplicationMutation, SetAntiFraudApplicantForLoanApplicationMutationVariables>;

/**
 * __useSetAntiFraudApplicantForLoanApplicationMutation__
 *
 * To run a mutation, you first call `useSetAntiFraudApplicantForLoanApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAntiFraudApplicantForLoanApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAntiFraudApplicantForLoanApplicationMutation, { data, loading, error }] = useSetAntiFraudApplicantForLoanApplicationMutation({
 *   variables: {
 *      applicantInput: // value for 'applicantInput'
 *   },
 * });
 */
export function useSetAntiFraudApplicantForLoanApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SetAntiFraudApplicantForLoanApplicationMutation, SetAntiFraudApplicantForLoanApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAntiFraudApplicantForLoanApplicationMutation, SetAntiFraudApplicantForLoanApplicationMutationVariables>(SetAntiFraudApplicantForLoanApplicationDocument, options);
      }
export type SetAntiFraudApplicantForLoanApplicationMutationHookResult = ReturnType<typeof useSetAntiFraudApplicantForLoanApplicationMutation>;
export type SetAntiFraudApplicantForLoanApplicationMutationResult = Apollo.MutationResult<SetAntiFraudApplicantForLoanApplicationMutation>;
export type SetAntiFraudApplicantForLoanApplicationMutationOptions = Apollo.BaseMutationOptions<SetAntiFraudApplicantForLoanApplicationMutation, SetAntiFraudApplicantForLoanApplicationMutationVariables>;
export const CreateCompanyInfoDocument = gql`
    mutation createCompanyInfo($loanApplicationId: ID!) {
  createCompanyInfo(loanApplicationId: $loanApplicationId) {
    id
  }
}
    `;
export type CreateCompanyInfoMutationFn = Apollo.MutationFunction<CreateCompanyInfoMutation, CreateCompanyInfoMutationVariables>;

/**
 * __useCreateCompanyInfoMutation__
 *
 * To run a mutation, you first call `useCreateCompanyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyInfoMutation, { data, loading, error }] = useCreateCompanyInfoMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useCreateCompanyInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyInfoMutation, CreateCompanyInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyInfoMutation, CreateCompanyInfoMutationVariables>(CreateCompanyInfoDocument, options);
      }
export type CreateCompanyInfoMutationHookResult = ReturnType<typeof useCreateCompanyInfoMutation>;
export type CreateCompanyInfoMutationResult = Apollo.MutationResult<CreateCompanyInfoMutation>;
export type CreateCompanyInfoMutationOptions = Apollo.BaseMutationOptions<CreateCompanyInfoMutation, CreateCompanyInfoMutationVariables>;
export const BuildChecklistDocument = gql`
    mutation buildChecklist($loanApplicationId: ID!) {
  buildChecklist(loanApplicationId: $loanApplicationId) {
    id
  }
}
    `;
export type BuildChecklistMutationFn = Apollo.MutationFunction<BuildChecklistMutation, BuildChecklistMutationVariables>;

/**
 * __useBuildChecklistMutation__
 *
 * To run a mutation, you first call `useBuildChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildChecklistMutation, { data, loading, error }] = useBuildChecklistMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useBuildChecklistMutation(baseOptions?: Apollo.MutationHookOptions<BuildChecklistMutation, BuildChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildChecklistMutation, BuildChecklistMutationVariables>(BuildChecklistDocument, options);
      }
export type BuildChecklistMutationHookResult = ReturnType<typeof useBuildChecklistMutation>;
export type BuildChecklistMutationResult = Apollo.MutationResult<BuildChecklistMutation>;
export type BuildChecklistMutationOptions = Apollo.BaseMutationOptions<BuildChecklistMutation, BuildChecklistMutationVariables>;
export const CompleteChecklistItemDocument = gql`
    mutation completeChecklistItem($loanApplicationId: ID!, $documentType: DocumentType!) {
  completeChecklistItem(
    loanApplicationId: $loanApplicationId
    documentType: $documentType
  ) {
    id
    checklist {
      items {
        allowedDocuments
        status
        origin
      }
    }
  }
}
    `;
export type CompleteChecklistItemMutationFn = Apollo.MutationFunction<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;

/**
 * __useCompleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useCompleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChecklistItemMutation, { data, loading, error }] = useCompleteChecklistItemMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useCompleteChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>(CompleteChecklistItemDocument, options);
      }
export type CompleteChecklistItemMutationHookResult = ReturnType<typeof useCompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationResult = Apollo.MutationResult<CompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;
export const CompleteSignerChecklistItemDocument = gql`
    mutation completeSignerChecklistItem($loanApplicationId: ID!, $signerId: ID!, $documentType: DocumentType!) {
  completeSignerChecklistItem(
    loanApplicationId: $loanApplicationId
    signerId: $signerId
    documentType: $documentType
  ) {
    id
    checklist {
      items {
        allowedDocuments
        status
        origin
      }
    }
    signers {
      checklist {
        items {
          allowedDocuments
          status
          origin
        }
      }
    }
  }
}
    `;
export type CompleteSignerChecklistItemMutationFn = Apollo.MutationFunction<CompleteSignerChecklistItemMutation, CompleteSignerChecklistItemMutationVariables>;

/**
 * __useCompleteSignerChecklistItemMutation__
 *
 * To run a mutation, you first call `useCompleteSignerChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSignerChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSignerChecklistItemMutation, { data, loading, error }] = useCompleteSignerChecklistItemMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      signerId: // value for 'signerId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useCompleteSignerChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSignerChecklistItemMutation, CompleteSignerChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSignerChecklistItemMutation, CompleteSignerChecklistItemMutationVariables>(CompleteSignerChecklistItemDocument, options);
      }
export type CompleteSignerChecklistItemMutationHookResult = ReturnType<typeof useCompleteSignerChecklistItemMutation>;
export type CompleteSignerChecklistItemMutationResult = Apollo.MutationResult<CompleteSignerChecklistItemMutation>;
export type CompleteSignerChecklistItemMutationOptions = Apollo.BaseMutationOptions<CompleteSignerChecklistItemMutation, CompleteSignerChecklistItemMutationVariables>;
export const GenerateSignerDocumentToUploadAsyncDocument = gql`
    mutation generateSignerDocumentToUploadAsync($loanApplicationId: ID!, $signerId: ID!, $documentType: DocumentType!, $documentOrigin: DocumentOrigin!, $contentType: String!, $filename: String!) {
  generateSignerDocumentToUploadAsync(
    loanApplicationId: $loanApplicationId
    signerId: $signerId
    documentType: $documentType
    documentOrigin: $documentOrigin
    contentType: $contentType
    filename: $filename
  ) {
    data
    url
    gcsUploadUrl
    gcsDocumentId
  }
}
    `;
export type GenerateSignerDocumentToUploadAsyncMutationFn = Apollo.MutationFunction<GenerateSignerDocumentToUploadAsyncMutation, GenerateSignerDocumentToUploadAsyncMutationVariables>;

/**
 * __useGenerateSignerDocumentToUploadAsyncMutation__
 *
 * To run a mutation, you first call `useGenerateSignerDocumentToUploadAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSignerDocumentToUploadAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSignerDocumentToUploadAsyncMutation, { data, loading, error }] = useGenerateSignerDocumentToUploadAsyncMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      signerId: // value for 'signerId'
 *      documentType: // value for 'documentType'
 *      documentOrigin: // value for 'documentOrigin'
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateSignerDocumentToUploadAsyncMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSignerDocumentToUploadAsyncMutation, GenerateSignerDocumentToUploadAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSignerDocumentToUploadAsyncMutation, GenerateSignerDocumentToUploadAsyncMutationVariables>(GenerateSignerDocumentToUploadAsyncDocument, options);
      }
export type GenerateSignerDocumentToUploadAsyncMutationHookResult = ReturnType<typeof useGenerateSignerDocumentToUploadAsyncMutation>;
export type GenerateSignerDocumentToUploadAsyncMutationResult = Apollo.MutationResult<GenerateSignerDocumentToUploadAsyncMutation>;
export type GenerateSignerDocumentToUploadAsyncMutationOptions = Apollo.BaseMutationOptions<GenerateSignerDocumentToUploadAsyncMutation, GenerateSignerDocumentToUploadAsyncMutationVariables>;
export const GenerateCompanyDocumentToUploadAsyncDocument = gql`
    mutation generateCompanyDocumentToUploadAsync($loanApplicationId: ID!, $documentType: DocumentType!, $documentOrigin: DocumentOrigin!, $contentType: String!, $filename: String!) {
  generateCompanyDocumentToUploadAsync(
    loanApplicationId: $loanApplicationId
    documentType: $documentType
    documentOrigin: $documentOrigin
    contentType: $contentType
    filename: $filename
  ) {
    data
    url
    gcsUploadUrl
    gcsDocumentId
  }
}
    `;
export type GenerateCompanyDocumentToUploadAsyncMutationFn = Apollo.MutationFunction<GenerateCompanyDocumentToUploadAsyncMutation, GenerateCompanyDocumentToUploadAsyncMutationVariables>;

/**
 * __useGenerateCompanyDocumentToUploadAsyncMutation__
 *
 * To run a mutation, you first call `useGenerateCompanyDocumentToUploadAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompanyDocumentToUploadAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCompanyDocumentToUploadAsyncMutation, { data, loading, error }] = useGenerateCompanyDocumentToUploadAsyncMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      documentType: // value for 'documentType'
 *      documentOrigin: // value for 'documentOrigin'
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateCompanyDocumentToUploadAsyncMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCompanyDocumentToUploadAsyncMutation, GenerateCompanyDocumentToUploadAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCompanyDocumentToUploadAsyncMutation, GenerateCompanyDocumentToUploadAsyncMutationVariables>(GenerateCompanyDocumentToUploadAsyncDocument, options);
      }
export type GenerateCompanyDocumentToUploadAsyncMutationHookResult = ReturnType<typeof useGenerateCompanyDocumentToUploadAsyncMutation>;
export type GenerateCompanyDocumentToUploadAsyncMutationResult = Apollo.MutationResult<GenerateCompanyDocumentToUploadAsyncMutation>;
export type GenerateCompanyDocumentToUploadAsyncMutationOptions = Apollo.BaseMutationOptions<GenerateCompanyDocumentToUploadAsyncMutation, GenerateCompanyDocumentToUploadAsyncMutationVariables>;
export const GenerateWorthyCreditFormDocument = gql`
    mutation generateWorthyCreditForm($loanApplicationId: ID!) {
  generateWorthyCreditForm(loanApplicationId: $loanApplicationId) {
    questionnaireUrl
  }
}
    `;
export type GenerateWorthyCreditFormMutationFn = Apollo.MutationFunction<GenerateWorthyCreditFormMutation, GenerateWorthyCreditFormMutationVariables>;

/**
 * __useGenerateWorthyCreditFormMutation__
 *
 * To run a mutation, you first call `useGenerateWorthyCreditFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorthyCreditFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorthyCreditFormMutation, { data, loading, error }] = useGenerateWorthyCreditFormMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useGenerateWorthyCreditFormMutation(baseOptions?: Apollo.MutationHookOptions<GenerateWorthyCreditFormMutation, GenerateWorthyCreditFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateWorthyCreditFormMutation, GenerateWorthyCreditFormMutationVariables>(GenerateWorthyCreditFormDocument, options);
      }
export type GenerateWorthyCreditFormMutationHookResult = ReturnType<typeof useGenerateWorthyCreditFormMutation>;
export type GenerateWorthyCreditFormMutationResult = Apollo.MutationResult<GenerateWorthyCreditFormMutation>;
export type GenerateWorthyCreditFormMutationOptions = Apollo.BaseMutationOptions<GenerateWorthyCreditFormMutation, GenerateWorthyCreditFormMutationVariables>;
export const FinishWorthyCreditFormDocument = gql`
    mutation finishWorthyCreditForm($loanApplicationId: ID!) {
  finishWorthyCreditForm(loanApplicationId: $loanApplicationId) {
    questionnaireUrl
    status
  }
}
    `;
export type FinishWorthyCreditFormMutationFn = Apollo.MutationFunction<FinishWorthyCreditFormMutation, FinishWorthyCreditFormMutationVariables>;

/**
 * __useFinishWorthyCreditFormMutation__
 *
 * To run a mutation, you first call `useFinishWorthyCreditFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishWorthyCreditFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishWorthyCreditFormMutation, { data, loading, error }] = useFinishWorthyCreditFormMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useFinishWorthyCreditFormMutation(baseOptions?: Apollo.MutationHookOptions<FinishWorthyCreditFormMutation, FinishWorthyCreditFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishWorthyCreditFormMutation, FinishWorthyCreditFormMutationVariables>(FinishWorthyCreditFormDocument, options);
      }
export type FinishWorthyCreditFormMutationHookResult = ReturnType<typeof useFinishWorthyCreditFormMutation>;
export type FinishWorthyCreditFormMutationResult = Apollo.MutationResult<FinishWorthyCreditFormMutation>;
export type FinishWorthyCreditFormMutationOptions = Apollo.BaseMutationOptions<FinishWorthyCreditFormMutation, FinishWorthyCreditFormMutationVariables>;
export const CompanyInfoCheckListDocument = gql`
    query companyInfoCheckList($loanApplicationId: ID!) {
  companyInfo(loanApplicationId: $loanApplicationId) {
    id
    isChecklistCompleted
    isChecklistUploadCompleted
    checklist {
      items {
        allowedDocuments
        status
        origin
        observation
        externalNotification
      }
      isCompleted
    }
    signers {
      id
      documentNumber
      name
      checklist {
        items {
          allowedDocuments
          status
          origin
          observation
          externalNotification
        }
        isCompleted
      }
    }
  }
}
    `;

/**
 * __useCompanyInfoCheckListQuery__
 *
 * To run a query within a React component, call `useCompanyInfoCheckListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInfoCheckListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInfoCheckListQuery({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useCompanyInfoCheckListQuery(baseOptions: Apollo.QueryHookOptions<CompanyInfoCheckListQuery, CompanyInfoCheckListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInfoCheckListQuery, CompanyInfoCheckListQueryVariables>(CompanyInfoCheckListDocument, options);
      }
export function useCompanyInfoCheckListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInfoCheckListQuery, CompanyInfoCheckListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInfoCheckListQuery, CompanyInfoCheckListQueryVariables>(CompanyInfoCheckListDocument, options);
        }
export type CompanyInfoCheckListQueryHookResult = ReturnType<typeof useCompanyInfoCheckListQuery>;
export type CompanyInfoCheckListLazyQueryHookResult = ReturnType<typeof useCompanyInfoCheckListLazyQuery>;
export type CompanyInfoCheckListQueryResult = Apollo.QueryResult<CompanyInfoCheckListQuery, CompanyInfoCheckListQueryVariables>;
export const CompanyInfoSignerDocument = gql`
    query companyInfoSigner($loanApplicationId: ID!, $signerId: ID!) {
  companyInfoSigner(loanApplicationId: $loanApplicationId, signerId: $signerId) {
    name
    hiddenDocument
  }
}
    `;

/**
 * __useCompanyInfoSignerQuery__
 *
 * To run a query within a React component, call `useCompanyInfoSignerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInfoSignerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInfoSignerQuery({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      signerId: // value for 'signerId'
 *   },
 * });
 */
export function useCompanyInfoSignerQuery(baseOptions: Apollo.QueryHookOptions<CompanyInfoSignerQuery, CompanyInfoSignerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInfoSignerQuery, CompanyInfoSignerQueryVariables>(CompanyInfoSignerDocument, options);
      }
export function useCompanyInfoSignerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInfoSignerQuery, CompanyInfoSignerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInfoSignerQuery, CompanyInfoSignerQueryVariables>(CompanyInfoSignerDocument, options);
        }
export type CompanyInfoSignerQueryHookResult = ReturnType<typeof useCompanyInfoSignerQuery>;
export type CompanyInfoSignerLazyQueryHookResult = ReturnType<typeof useCompanyInfoSignerLazyQuery>;
export type CompanyInfoSignerQueryResult = Apollo.QueryResult<CompanyInfoSignerQuery, CompanyInfoSignerQueryVariables>;
export const CompanyInfoDocument = gql`
    query companyInfo($loanApplicationId: ID!) {
  companyInfo(loanApplicationId: $loanApplicationId) {
    id
  }
}
    `;

/**
 * __useCompanyInfoQuery__
 *
 * To run a query within a React component, call `useCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInfoQuery({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useCompanyInfoQuery(baseOptions: Apollo.QueryHookOptions<CompanyInfoQuery, CompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInfoQuery, CompanyInfoQueryVariables>(CompanyInfoDocument, options);
      }
export function useCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInfoQuery, CompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInfoQuery, CompanyInfoQueryVariables>(CompanyInfoDocument, options);
        }
export type CompanyInfoQueryHookResult = ReturnType<typeof useCompanyInfoQuery>;
export type CompanyInfoLazyQueryHookResult = ReturnType<typeof useCompanyInfoLazyQuery>;
export type CompanyInfoQueryResult = Apollo.QueryResult<CompanyInfoQuery, CompanyInfoQueryVariables>;


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AccountabilityComprobationKind: AccountabilityComprobationKind;
  AccountabilityDestinationKind: AccountabilityDestinationKind;
  AccountabilityDocument: ResolverTypeWrapper<AccountabilityDocument>;
  AccountabilityDocumentInput: AccountabilityDocumentInput;
  Address: ResolverTypeWrapper<Address>;
  AddressInput: AddressInput;
  AlienatedItem: ResolverTypeWrapper<AlienatedItem>;
  Answer: ResolverTypeWrapper<Answer>;
  AnswerInput: AnswerInput;
  AnswerType: AnswerType;
  AntiFraud: ResolverTypeWrapper<AntiFraud>;
  Applicant: ResolverTypeWrapper<Applicant>;
  ApplicantInput: ApplicantInput;
  ApplicantRelationship: ApplicantRelationship;
  ApplicantResultType: ResolversTypes['Applicant'] | ResolversTypes['InvalidApplicant'];
  AuthorityDecisionKind: AuthorityDecisionKind;
  AuthorityDecisionReason: ResolverTypeWrapper<AuthorityDecisionReason>;
  AuthorityDecisionReasonInput: AuthorityDecisionReasonInput;
  AuthorityLevel: AuthorityLevel;
  AutomaticAuthorityDecision: ResolverTypeWrapper<AutomaticAuthorityDecision>;
  AutomaticAuthorityDecisionCache: ResolverTypeWrapper<AutomaticAuthorityDecisionCache>;
  AutomaticAuthorityDecisionInput: AutomaticAuthorityDecisionInput;
  Bank: ResolverTypeWrapper<Bank>;
  BankAccount: ResolverTypeWrapper<BankAccount>;
  BankAccountInfo: ResolverTypeWrapper<BankAccountInfo>;
  BankAccountInfoInput: BankAccountInfoInput;
  BankAccountInput: BankAccountInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Borrower: ResolverTypeWrapper<Borrower>;
  BorrowerInfo: ResolverTypeWrapper<BorrowerInfo>;
  BorrowerInfoInput: BorrowerInfoInput;
  BorrowerRelationship: BorrowerRelationship;
  ChangeTracker: ResolverTypeWrapper<ChangeTracker>;
  ChangeTrackerInput: ChangeTrackerInput;
  Checklist: ResolverTypeWrapper<Checklist>;
  ChecklistInput: ChecklistInput;
  ChecklistItem: ResolverTypeWrapper<ChecklistItem>;
  ChecklistItemInput: ChecklistItemInput;
  ChecklistItemOrigin: ChecklistItemOrigin;
  ChecklistItemStatus: ChecklistItemStatus;
  City: ResolverTypeWrapper<City>;
  ClientCategory: ClientCategory;
  Collection: ResolverTypeWrapper<Collection>;
  CollectionSource: CollectionSource;
  CompanyInfo: ResolverTypeWrapper<CompanyInfo>;
  CompanyInfoPagination: ResolverTypeWrapper<CompanyInfoPagination>;
  CompanyInfoSpecInput: CompanyInfoSpecInput;
  ContentType: ContentType;
  CreditAnalysis: ResolverTypeWrapper<CreditAnalysis>;
  CreditAnalysisInput: CreditAnalysisInput;
  CreditAnalysisStatus: CreditAnalysisStatus;
  CreditAnalyst: ResolverTypeWrapper<CreditAnalyst>;
  CreditAnalystAuthorityLimits: ResolverTypeWrapper<CreditAnalystAuthorityLimits>;
  CreditAnalystAuthorityLimitsInput: CreditAnalystAuthorityLimitsInput;
  CreditAnalystInput: CreditAnalystInput;
  CreditOpinion: ResolverTypeWrapper<CreditOpinion>;
  CreditOpinionInput: CreditOpinionInput;
  CreditOpinionStatus: CreditOpinionStatus;
  Credit_LegacyRelationship: ResolverTypeWrapper<Credit_LegacyRelationship>;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  Decimal: ResolverTypeWrapper<Scalars['Decimal']>;
  Document: ResolverTypeWrapper<Document>;
  DocumentOrigin: DocumentOrigin;
  DocumentType: DocumentType;
  DocumentUploadS3: ResolverTypeWrapper<DocumentUploadS3>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Gender: Gender;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  InvalidApplicant: ResolverTypeWrapper<InvalidApplicant>;
  InvalidApplicantReason: InvalidApplicantReason;
  InvalidQuestionsCount: ResolverTypeWrapper<InvalidQuestionsCount>;
  LegacyBizu: ResolverTypeWrapper<LegacyBizu>;
  LegacyChecklistScore: ResolverTypeWrapper<LegacyChecklistScore>;
  LegacyClearSaleData: ResolverTypeWrapper<LegacyClearSaleData>;
  LegacyClearSaleInsight: ResolverTypeWrapper<LegacyClearSaleInsight>;
  LegacyClearSaleRating: ResolverTypeWrapper<LegacyClearSaleRating>;
  LegacyClearSaleResults: ResolverTypeWrapper<LegacyClearSaleResults>;
  LegacyClearSaleScore: ResolverTypeWrapper<LegacyClearSaleScore>;
  LegacyCreditWorthiness: ResolverTypeWrapper<LegacyCreditWorthiness>;
  LegacyLoanApplication: ResolverTypeWrapper<LegacyLoanApplication>;
  LegacyProduct: ResolverTypeWrapper<LegacyProduct>;
  LegacyProposal: ResolverTypeWrapper<LegacyProposal>;
  LegacyRelationshipInput: LegacyRelationshipInput;
  LegacyRenewalInformation: ResolverTypeWrapper<LegacyRenewalInformation>;
  LegacySerasa: ResolverTypeWrapper<LegacySerasa>;
  LegacyStatementScore: ResolverTypeWrapper<LegacyStatementScore>;
  LegacyStatementScoreBigGuys: ResolverTypeWrapper<LegacyStatementScoreBigGuys>;
  Liveness: ResolverTypeWrapper<Liveness>;
  LivenessSharedUrl: ResolverTypeWrapper<LivenessSharedUrl>;
  LivenessStatus: LivenessStatus;
  LoanAccountability: ResolverTypeWrapper<LoanAccountability>;
  LoanAccountabilityInput: LoanAccountabilityInput;
  LoanApplicationRef: ResolverTypeWrapper<LoanApplicationRef>;
  LoanApplicationStatus: LoanApplicationStatus;
  Loan_LegacyRelationship: ResolverTypeWrapper<Loan_LegacyRelationship>;
  MaritalStatus: MaritalStatus;
  Mutation: ResolverTypeWrapper<{}>;
  Nationality: Nationality;
  PaymentInterval: PaymentInterval;
  PreQualifiedLoan: ResolverTypeWrapper<PreQualifiedLoan>;
  PreQualifiedLoanInput: PreQualifiedLoanInput;
  PreQualifiedLoanOwner: PreQualifiedLoanOwner;
  PreQualifiedLoanStatus: PreQualifiedLoanStatus;
  PreQualifiedPagination: ResolverTypeWrapper<PreQualifiedPagination>;
  PreQualifiedSpecificationInputType: PreQualifiedSpecificationInputType;
  PredefinedMotive: ResolverTypeWrapper<PredefinedMotive>;
  PredefinedMotiveInput: PredefinedMotiveInput;
  Query: ResolverTypeWrapper<{}>;
  Question: ResolverTypeWrapper<Question>;
  QuestionInput: QuestionInput;
  QuestionnaireType: QuestionnaireType;
  RelatedPerson: ResolverTypeWrapper<RelatedPerson>;
  RelatedPersonInput: RelatedPersonInput;
  RelatedPersonType: RelatedPersonType;
  Signer: ResolverTypeWrapper<Signer>;
  SignerInput: SignerInput;
  Spouse: ResolverTypeWrapper<Spouse>;
  SpouseInput: SpouseInput;
  State: ResolverTypeWrapper<State>;
  String: ResolverTypeWrapper<Scalars['String']>;
  SuggestionType: SuggestionType;
  WorthyCredit: ResolverTypeWrapper<WorthyCredit>;
  WorthyCreditResults: ResolverTypeWrapper<WorthyCreditResults>;
  WorthyCreditStatus: WorthyCreditStatus;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AccountabilityDocument: AccountabilityDocument;
  AccountabilityDocumentInput: AccountabilityDocumentInput;
  Address: Address;
  AddressInput: AddressInput;
  AlienatedItem: AlienatedItem;
  Answer: Answer;
  AnswerInput: AnswerInput;
  AntiFraud: AntiFraud;
  Applicant: Applicant;
  ApplicantInput: ApplicantInput;
  ApplicantResultType: ResolversParentTypes['Applicant'] | ResolversParentTypes['InvalidApplicant'];
  AuthorityDecisionReason: AuthorityDecisionReason;
  AuthorityDecisionReasonInput: AuthorityDecisionReasonInput;
  AutomaticAuthorityDecision: AutomaticAuthorityDecision;
  AutomaticAuthorityDecisionCache: AutomaticAuthorityDecisionCache;
  AutomaticAuthorityDecisionInput: AutomaticAuthorityDecisionInput;
  Bank: Bank;
  BankAccount: BankAccount;
  BankAccountInfo: BankAccountInfo;
  BankAccountInfoInput: BankAccountInfoInput;
  BankAccountInput: BankAccountInput;
  Boolean: Scalars['Boolean'];
  Borrower: Borrower;
  BorrowerInfo: BorrowerInfo;
  BorrowerInfoInput: BorrowerInfoInput;
  ChangeTracker: ChangeTracker;
  ChangeTrackerInput: ChangeTrackerInput;
  Checklist: Checklist;
  ChecklistInput: ChecklistInput;
  ChecklistItem: ChecklistItem;
  ChecklistItemInput: ChecklistItemInput;
  City: City;
  Collection: Collection;
  CompanyInfo: CompanyInfo;
  CompanyInfoPagination: CompanyInfoPagination;
  CompanyInfoSpecInput: CompanyInfoSpecInput;
  CreditAnalysis: CreditAnalysis;
  CreditAnalysisInput: CreditAnalysisInput;
  CreditAnalyst: CreditAnalyst;
  CreditAnalystAuthorityLimits: CreditAnalystAuthorityLimits;
  CreditAnalystAuthorityLimitsInput: CreditAnalystAuthorityLimitsInput;
  CreditAnalystInput: CreditAnalystInput;
  CreditOpinion: CreditOpinion;
  CreditOpinionInput: CreditOpinionInput;
  Credit_LegacyRelationship: Credit_LegacyRelationship;
  Date: Scalars['Date'];
  DateTime: Scalars['DateTime'];
  Decimal: Scalars['Decimal'];
  Document: Document;
  DocumentUploadS3: DocumentUploadS3;
  Float: Scalars['Float'];
  ID: Scalars['ID'];
  Int: Scalars['Int'];
  InvalidApplicant: InvalidApplicant;
  InvalidQuestionsCount: InvalidQuestionsCount;
  LegacyBizu: LegacyBizu;
  LegacyChecklistScore: LegacyChecklistScore;
  LegacyClearSaleData: LegacyClearSaleData;
  LegacyClearSaleInsight: LegacyClearSaleInsight;
  LegacyClearSaleRating: LegacyClearSaleRating;
  LegacyClearSaleResults: LegacyClearSaleResults;
  LegacyClearSaleScore: LegacyClearSaleScore;
  LegacyCreditWorthiness: LegacyCreditWorthiness;
  LegacyLoanApplication: LegacyLoanApplication;
  LegacyProduct: LegacyProduct;
  LegacyProposal: LegacyProposal;
  LegacyRelationshipInput: LegacyRelationshipInput;
  LegacyRenewalInformation: LegacyRenewalInformation;
  LegacySerasa: LegacySerasa;
  LegacyStatementScore: LegacyStatementScore;
  LegacyStatementScoreBigGuys: LegacyStatementScoreBigGuys;
  Liveness: Liveness;
  LivenessSharedUrl: LivenessSharedUrl;
  LoanAccountability: LoanAccountability;
  LoanAccountabilityInput: LoanAccountabilityInput;
  LoanApplicationRef: LoanApplicationRef;
  Loan_LegacyRelationship: Loan_LegacyRelationship;
  Mutation: {};
  PreQualifiedLoan: PreQualifiedLoan;
  PreQualifiedLoanInput: PreQualifiedLoanInput;
  PreQualifiedPagination: PreQualifiedPagination;
  PreQualifiedSpecificationInputType: PreQualifiedSpecificationInputType;
  PredefinedMotive: PredefinedMotive;
  PredefinedMotiveInput: PredefinedMotiveInput;
  Query: {};
  Question: Question;
  QuestionInput: QuestionInput;
  RelatedPerson: RelatedPerson;
  RelatedPersonInput: RelatedPersonInput;
  Signer: Signer;
  SignerInput: SignerInput;
  Spouse: Spouse;
  SpouseInput: SpouseInput;
  State: State;
  String: Scalars['String'];
  WorthyCredit: WorthyCredit;
  WorthyCreditResults: WorthyCreditResults;
};

export type AccountabilityDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountabilityDocument'] = ResolversParentTypes['AccountabilityDocument']> = {
  comprobationKind?: Resolver<Maybe<ResolversTypes['AccountabilityComprobationKind']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  destinationKind?: Resolver<Maybe<ResolversTypes['AccountabilityDestinationKind']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  observations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  cityId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  complement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  neighbourhood?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlienatedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlienatedItem'] = ResolversParentTypes['AlienatedItem']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fabricator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Answer'] = ResolversParentTypes['Answer']> = {
  answerText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  answerType?: Resolver<Maybe<ResolversTypes['AnswerType']>, ParentType, ContextType>;
  booleanReply?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cancelAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['ContentType']>, ParentType, ContextType>;
  dependsOfAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  discursiveReply?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showOnResume?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AntiFraudResolvers<ContextType = any, ParentType extends ResolversParentTypes['AntiFraud'] = ResolversParentTypes['AntiFraud']> = {
  applicant?: Resolver<Maybe<ResolversTypes['Applicant']>, ParentType, ContextType>;
  isCompleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  livenessStatus?: Resolver<Maybe<ResolversTypes['LivenessStatus']>, ParentType, ContextType>;
  worthyCreditStatus?: Resolver<Maybe<ResolversTypes['WorthyCreditStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantResolvers<ContextType = any, ParentType extends ResolversParentTypes['Applicant'] = ResolversParentTypes['Applicant']> = {
  relationship?: Resolver<Maybe<ResolversTypes['ApplicantRelationship']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantResultTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantResultType'] = ResolversParentTypes['ApplicantResultType']> = {
  __resolveType: TypeResolveFn<'Applicant' | 'InvalidApplicant', ParentType, ContextType>;
};

export type AuthorityDecisionReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorityDecisionReason'] = ResolversParentTypes['AuthorityDecisionReason']> = {
  amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  assignmentCommissionModifier?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  bizuCombo?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  decision?: Resolver<Maybe<ResolversTypes['AuthorityDecisionKind']>, ParentType, ContextType>;
  informedRevenue?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  interestRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  needPsychometric?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenure?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  verifiedRevenue?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutomaticAuthorityDecisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomaticAuthorityDecision'] = ResolversParentTypes['AutomaticAuthorityDecision']> = {
  decision?: Resolver<Maybe<ResolversTypes['AuthorityDecisionKind']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuthorityDecisionReason']>>>, ParentType, ContextType>;
  revenueComprovationRatio?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  verifiedRevenue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutomaticAuthorityDecisionCacheResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomaticAuthorityDecisionCache'] = ResolversParentTypes['AutomaticAuthorityDecisionCache']> = {
  data?: Resolver<Maybe<ResolversTypes['AutomaticAuthorityDecision']>, ParentType, ContextType>;
  processing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bank'] = ResolversParentTypes['Bank']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mostUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = {
  account?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isAutomaticDebit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isBizConta?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLegalPersonAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountInfo'] = ResolversParentTypes['BankAccountInfo']> = {
  account?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BorrowerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Borrower'] = ResolversParentTypes['Borrower']> = {
  activitySector?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  cnae?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cnaeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyDocument?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foundationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isMEI?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  legacyRelationship?: Resolver<Maybe<ResolversTypes['Credit_LegacyRelationship']>, ParentType, ContextType>;
  legalNature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  monthlyRevenue?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relationship?: Resolver<Maybe<ResolversTypes['BorrowerRelationship']>, ParentType, ContextType>;
  responsibleDocument?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responsibleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simplesNacional?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stateRegistration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yearlyRevenue?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BorrowerInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BorrowerInfo'] = ResolversParentTypes['BorrowerInfo']> = {
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccountInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeTrackerResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeTracker'] = ResolversParentTypes['ChangeTracker']> = {
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChecklistResolvers<ContextType = any, ParentType extends ResolversParentTypes['Checklist'] = ResolversParentTypes['Checklist']> = {
  isCompleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChecklistItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChecklistItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChecklistItem'] = ResolversParentTypes['ChecklistItem']> = {
  allowedDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocumentType']>>>, ParentType, ContextType>;
  externalNotification?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['ChecklistItemOrigin']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ChecklistItemStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CityResolvers<ContextType = any, ParentType extends ResolversParentTypes['City'] = ResolversParentTypes['City']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['State'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Collection'] = ResolversParentTypes['Collection']> = {
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  resultAsJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyInfo'] = ResolversParentTypes['CompanyInfo']> = {
  borrower?: Resolver<Maybe<ResolversTypes['Borrower']>, ParentType, ContextType>;
  checklist?: Resolver<Maybe<ResolversTypes['Checklist']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  creditAnalyst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isBizAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isChecklistCompleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isChecklistUploadCompleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastCreditAnalysis?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType>;
  lastLegacyCreditWorthiness?: Resolver<Maybe<ResolversTypes['LegacyCreditWorthiness']>, ParentType, ContextType>;
  legacyloanApplication?: Resolver<Maybe<ResolversTypes['LegacyLoanApplication']>, ParentType, ContextType>;
  loanApplicationRef?: Resolver<Maybe<ResolversTypes['LoanApplicationRef']>, ParentType, ContextType>;
  majorSigner?: Resolver<Maybe<ResolversTypes['Signer']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['LegacyProduct']>, ParentType, ContextType>;
  signers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Signer']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyInfoPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyInfoPagination'] = ResolversParentTypes['CompanyInfoPagination']> = {
  currentPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  records?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompanyInfo']>>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditAnalysisResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditAnalysis'] = ResolversParentTypes['CreditAnalysis']> = {
  creditOpinions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditOpinion']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  invalidQuestionsMap?: Resolver<Maybe<Array<Maybe<ResolversTypes['InvalidQuestionsCount']>>>, ParentType, ContextType>;
  questionnaire?: Resolver<Maybe<Array<Maybe<ResolversTypes['Question']>>>, ParentType, ContextType>;
  relatedPeople?: Resolver<Maybe<Array<Maybe<ResolversTypes['RelatedPerson']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CreditAnalysisStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditAnalystResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditAnalyst'] = ResolversParentTypes['CreditAnalyst']> = {
  authorityLimits?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditAnalystAuthorityLimits']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditAnalystAuthorityLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditAnalystAuthorityLimits'] = ResolversParentTypes['CreditAnalystAuthorityLimits']> = {
  amountLimmitAprovation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  authorityLevel?: Resolver<Maybe<ResolversTypes['AuthorityLevel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditOpinionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditOpinion'] = ResolversParentTypes['CreditOpinion']> = {
  authorityLevel?: Resolver<Maybe<ResolversTypes['AuthorityLevel']>, ParentType, ContextType>;
  changes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChangeTracker']>>>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditOpinionSuggestionType?: Resolver<Maybe<ResolversTypes['SuggestionType']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isAutomatic?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastChange?: Resolver<Maybe<ResolversTypes['ChangeTracker']>, ParentType, ContextType>;
  newAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  newInterestRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  newTenure?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  selectedMotives?: Resolver<Maybe<Array<Maybe<ResolversTypes['PredefinedMotive']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CreditOpinionStatus']>, ParentType, ContextType>;
  trustLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credit_LegacyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Credit_LegacyRelationship'] = ResolversParentTypes['Credit_LegacyRelationship']> = {
  clientId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  documentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export interface DecimalScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Decimal'], any> {
  name: 'Decimal';
}

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = {
  discardedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  documentDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fileExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  insertedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDiscarded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOnTempBucket?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  legacyRelationship?: Resolver<Maybe<ResolversTypes['Credit_LegacyRelationship']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['DocumentOrigin']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['DocumentType']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentUploadS3Resolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentUploadS3'] = ResolversParentTypes['DocumentUploadS3']> = {
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidApplicantResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidApplicant'] = ResolversParentTypes['InvalidApplicant']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['InvalidApplicantReason']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidQuestionsCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidQuestionsCount'] = ResolversParentTypes['InvalidQuestionsCount']> = {
  key?: Resolver<Maybe<ResolversTypes['QuestionnaireType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyBizuResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyBizu'] = ResolversParentTypes['LegacyBizu']> = {
  bizuIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bizuScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bizuVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyChecklistScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyChecklistScore'] = ResolversParentTypes['LegacyChecklistScore']> = {
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyClearSaleDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyClearSaleData'] = ResolversParentTypes['LegacyClearSaleData']> = {
  document?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  results?: Resolver<Maybe<ResolversTypes['LegacyClearSaleResults']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifiedPhone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyClearSaleInsightResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyClearSaleInsight'] = ResolversParentTypes['LegacyClearSaleInsight']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relatedTo?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  relevance?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyClearSaleRatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyClearSaleRating'] = ResolversParentTypes['LegacyClearSaleRating']> = {
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relatedTo?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyClearSaleResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyClearSaleResults'] = ResolversParentTypes['LegacyClearSaleResults']> = {
  insights?: Resolver<Maybe<Array<Maybe<ResolversTypes['LegacyClearSaleInsight']>>>, ParentType, ContextType>;
  ratings?: Resolver<Maybe<Array<Maybe<ResolversTypes['LegacyClearSaleRating']>>>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['LegacyClearSaleScore']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyClearSaleScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyClearSaleScore'] = ResolversParentTypes['LegacyClearSaleScore']> = {
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyCreditWorthinessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyCreditWorthiness'] = ResolversParentTypes['LegacyCreditWorthiness']> = {
  bigGuysScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bizu?: Resolver<Maybe<ResolversTypes['LegacyBizu']>, ParentType, ContextType>;
  bizu3?: Resolver<Maybe<ResolversTypes['LegacyBizu']>, ParentType, ContextType>;
  bizuComboZoneNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checklistScore?: Resolver<Maybe<ResolversTypes['LegacyChecklistScore']>, ParentType, ContextType>;
  clearSale?: Resolver<Maybe<ResolversTypes['LegacyClearSaleData']>, ParentType, ContextType>;
  clientCategory?: Resolver<Maybe<ResolversTypes['ClientCategory']>, ParentType, ContextType>;
  loanApplicationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  processingStart?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  psychometricScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  serasa?: Resolver<Maybe<ResolversTypes['LegacySerasa']>, ParentType, ContextType>;
  statementScore?: Resolver<Maybe<ResolversTypes['LegacyStatementScore']>, ParentType, ContextType>;
  statementScoreBigGuys?: Resolver<Maybe<ResolversTypes['LegacyStatementScoreBigGuys']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyLoanApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyLoanApplication'] = ResolversParentTypes['LegacyLoanApplication']> = {
  acceptedProposal?: Resolver<Maybe<ResolversTypes['LegacyProposal']>, ParentType, ContextType>;
  alienatedItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['AlienatedItem']>>>, ParentType, ContextType>;
  amountRequested?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  approvedProposal?: Resolver<Maybe<ResolversTypes['LegacyProposal']>, ParentType, ContextType>;
  creditAnalyst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  documentsAnalyst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  insideSalesAnalyst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastProposal?: Resolver<Maybe<ResolversTypes['LegacyProposal']>, ParentType, ContextType>;
  legacyRelationship?: Resolver<Maybe<ResolversTypes['Loan_LegacyRelationship']>, ParentType, ContextType>;
  optInIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proposals?: Resolver<Maybe<Array<Maybe<ResolversTypes['LegacyProposal']>>>, ParentType, ContextType>;
  reasonDetail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  renewalInformation?: Resolver<Maybe<ResolversTypes['LegacyRenewalInformation']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['LoanApplicationStatus']>, ParentType, ContextType>;
  utmSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyProduct'] = ResolversParentTypes['LegacyProduct']> = {
  bizId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxAmountToRequest?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  maxNumberOfInstallments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxNumberOfInstallmentsForWeeklyInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minAmountToRequest?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  minInterestRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  minNumberOfInstallments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minNumberOfInstallmentsForWeeklyInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paymentInterval?: Resolver<Maybe<ResolversTypes['PaymentInterval']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyProposalResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyProposal'] = ResolversParentTypes['LegacyProposal']> = {
  amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  commission?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  downPayments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fixedComission?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  interestRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  paymentDay?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentInterval?: Resolver<Maybe<ResolversTypes['PaymentInterval']>, ParentType, ContextType>;
  tenure?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyRenewalInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyRenewalInformation'] = ResolversParentTypes['LegacyRenewalInformation']> = {
  previousLoans?: Resolver<Maybe<Array<Maybe<ResolversTypes['ID']>>>, ParentType, ContextType>;
  previousLoansCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacySerasaResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacySerasa'] = ResolversParentTypes['LegacySerasa']> = {
  serasaScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  serasaVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyStatementScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyStatementScore'] = ResolversParentTypes['LegacyStatementScore']> = {
  indicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyStatementScoreBigGuysResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyStatementScoreBigGuys'] = ResolversParentTypes['LegacyStatementScoreBigGuys']> = {
  indicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  policy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivenessResolvers<ContextType = any, ParentType extends ResolversParentTypes['Liveness'] = ResolversParentTypes['Liveness']> = {
  sharedUrl?: Resolver<Maybe<ResolversTypes['LivenessSharedUrl']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['LivenessStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivenessSharedUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['LivenessSharedUrl'] = ResolversParentTypes['LivenessSharedUrl']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanAccountabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanAccountability'] = ResolversParentTypes['LoanAccountability']> = {
  documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountabilityDocument']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanApplicationRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanApplicationRef'] = ResolversParentTypes['LoanApplicationRef']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Loan_LegacyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Loan_LegacyRelationship'] = ResolversParentTypes['Loan_LegacyRelationship']> = {
  clientId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  leadId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  loanRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  offerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  adjustCompanyInfoChecklistForProduct?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationAdjustCompanyInfoChecklistForProductArgs, 'loanApplicationId'>>;
  backToPreviousCreditOpinion?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationBackToPreviousCreditOpinionArgs, 'companyInfoId' | 'creditAnalysisId' | 'creditOpinionInput'>>;
  buildChecklist?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationBuildChecklistArgs, 'loanApplicationId'>>;
  callAutomations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCallAutomationsArgs, 'companyInfoId' | 'creditAnalysisId'>>;
  callbackCreditAutomations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCallbackCreditAutomationsArgs, 'automaticAuthorityDecisionInput'>>;
  completeChecklistItem?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationCompleteChecklistItemArgs, 'documentType' | 'loanApplicationId'>>;
  completeSignerChecklistItem?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationCompleteSignerChecklistItemArgs, 'documentType' | 'loanApplicationId' | 'signerId'>>;
  createAntifraudForLoanApplication?: Resolver<Maybe<ResolversTypes['AntiFraud']>, ParentType, ContextType, RequireFields<MutationCreateAntifraudForLoanApplicationArgs, 'loanApplicationId'>>;
  createBooleanQuestion?: Resolver<Maybe<ResolversTypes['Question']>, ParentType, ContextType, RequireFields<MutationCreateBooleanQuestionArgs, 'asking' | 'noWeight' | 'questionnaireType' | 'required' | 'yesWeight'>>;
  createCompanyInfo?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationCreateCompanyInfoArgs, 'loanApplicationId'>>;
  createPreQualifiedLoan?: Resolver<Maybe<ResolversTypes['PreQualifiedLoan']>, ParentType, ContextType, RequireFields<MutationCreatePreQualifiedLoanArgs, 'preQualifiedLoanInput'>>;
  deleteCreditAnalyst?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationDeleteCreditAnalystArgs, 'creditAnalystInput'>>;
  deleteCreditOpinion?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationDeleteCreditOpinionArgs, 'companyInfoId' | 'creditAnalysisId' | 'creditOpinionInput'>>;
  deleteDocument?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationDeleteDocumentArgs, 'documentId' | 'loanApplicationId' | 'ownerId'>>;
  deletePredefinedMotive?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationDeletePredefinedMotiveArgs, 'predefinedMotiveInput'>>;
  deleteQuestion?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationDeleteQuestionArgs, 'questionInput'>>;
  deleteRelatedPerson?: Resolver<Maybe<ResolversTypes['RelatedPerson']>, ParentType, ContextType, RequireFields<MutationDeleteRelatedPersonArgs, 'companyInfoId' | 'creditAnalysisId' | 'relatedPersonDocument'>>;
  deleteSigner?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationDeleteSignerArgs, 'loanApplicationId' | 'signerId'>>;
  finishUserLivenessOnboarding?: Resolver<Maybe<ResolversTypes['Liveness']>, ParentType, ContextType, RequireFields<MutationFinishUserLivenessOnboardingArgs, 'loanApplicationId'>>;
  finishWorthyCreditForm?: Resolver<Maybe<ResolversTypes['WorthyCredit']>, ParentType, ContextType, RequireFields<MutationFinishWorthyCreditFormArgs, 'loanApplicationId'>>;
  generateCompanyDocumentToUploadAsync?: Resolver<Maybe<ResolversTypes['DocumentUploadS3']>, ParentType, ContextType, RequireFields<MutationGenerateCompanyDocumentToUploadAsyncArgs, 'contentType' | 'documentOrigin' | 'documentType' | 'filename' | 'loanApplicationId'>>;
  generateSharedUrl?: Resolver<Maybe<ResolversTypes['LivenessSharedUrl']>, ParentType, ContextType, RequireFields<MutationGenerateSharedUrlArgs, 'loanApplicationId'>>;
  generateSignerDocumentToUploadAsync?: Resolver<Maybe<ResolversTypes['DocumentUploadS3']>, ParentType, ContextType, RequireFields<MutationGenerateSignerDocumentToUploadAsyncArgs, 'contentType' | 'documentOrigin' | 'documentType' | 'filename' | 'loanApplicationId' | 'signerId'>>;
  generateWorthyCreditForm?: Resolver<Maybe<ResolversTypes['WorthyCredit']>, ParentType, ContextType, RequireFields<MutationGenerateWorthyCreditFormArgs, 'loanApplicationId'>>;
  insertRelatedPerson?: Resolver<Maybe<ResolversTypes['RelatedPerson']>, ParentType, ContextType, RequireFields<MutationInsertRelatedPersonArgs, 'companyInfoId' | 'creditAnalysisId' | 'relatedPersonInput'>>;
  manuallyQualifyDocument?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationManuallyQualifyDocumentArgs, 'destinyId' | 'documentId' | 'documentType' | 'loanApplicationId' | 'originId'>>;
  replaceLastCreditOpinion?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationReplaceLastCreditOpinionArgs, 'companyInfoId' | 'creditAnalysisId'>>;
  requestCreditOpinionReview?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationRequestCreditOpinionReviewArgs, 'companyInfoId' | 'creditAnalysisId' | 'creditOpinionInput'>>;
  requestSyncQualificationResult?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRequestSyncQualificationResultArgs, 'loanApplicationId'>>;
  requestWorthyCredit?: Resolver<Maybe<ResolversTypes['AntiFraud']>, ParentType, ContextType, RequireFields<MutationRequestWorthyCreditArgs, 'loanApplicationId'>>;
  resetQuestionnaire?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationResetQuestionnaireArgs, 'companyInfoId' | 'creditAnalysisId'>>;
  saveCreditAnalyst?: Resolver<Maybe<ResolversTypes['CreditAnalyst']>, ParentType, ContextType, RequireFields<MutationSaveCreditAnalystArgs, 'creditAnalystInput'>>;
  savePredefinedMotive?: Resolver<Maybe<ResolversTypes['PredefinedMotive']>, ParentType, ContextType, RequireFields<MutationSavePredefinedMotiveArgs, 'predefinedMotiveInput'>>;
  saveQuestion?: Resolver<Maybe<ResolversTypes['Question']>, ParentType, ContextType, RequireFields<MutationSaveQuestionArgs, 'questionInput'>>;
  sendBackToFirstAuthority?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationSendBackToFirstAuthorityArgs, 'companyInfoId' | 'creditAnalysisId'>>;
  sendBackToPreAuthority?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationSendBackToPreAuthorityArgs, 'companyInfoId' | 'creditAnalysisId'>>;
  sendToAuthority?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationSendToAuthorityArgs, 'companyInfoId'>>;
  setAntiFraudApplicantForLoanApplication?: Resolver<Maybe<ResolversTypes['ApplicantResultType']>, ParentType, ContextType, RequireFields<MutationSetAntiFraudApplicantForLoanApplicationArgs, 'applicantInput'>>;
  setAsCreditInvestigation?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationSetAsCreditInvestigationArgs, 'companyInfoId' | 'creditAnalysisId' | 'creditOpinionInput'>>;
  setCompanyInfoLegacyRelationship?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationSetCompanyInfoLegacyRelationshipArgs, 'legacyClientId' | 'loanApplicationId'>>;
  setCreditAnalyst?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationSetCreditAnalystArgs, 'companyInfoId'>>;
  startCreditAnalysis?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationStartCreditAnalysisArgs, 'loanApplicationId'>>;
  submitCreditOpinion?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationSubmitCreditOpinionArgs, 'companyInfoId' | 'creditAnalysisId' | 'creditOpinionInput'>>;
  unsetCreditAnalyst?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationUnsetCreditAnalystArgs, 'companyInfoId' | 'username'>>;
  updateCompanyInfoAddress?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyInfoAddressArgs, 'addressInput' | 'loanApplicationId'>>;
  updateCompanyInfoBankAccount?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyInfoBankAccountArgs, 'bankAccountInput' | 'loanApplicationId'>>;
  updateCompanyInfoChecklist?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyInfoChecklistArgs, 'checklistInput' | 'loanApplicationId'>>;
  updateCreditAnalysisChecklist?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationUpdateCreditAnalysisChecklistArgs, 'companyInfoId' | 'creditAnalysisInput'>>;
  updateCreditAnalysisOpinion?: Resolver<Maybe<ResolversTypes['CreditAnalysis']>, ParentType, ContextType, RequireFields<MutationUpdateCreditAnalysisOpinionArgs, 'companyInfoId' | 'creditAnalysisId' | 'creditOpinionInput'>>;
  updateLoanAccountability?: Resolver<Maybe<ResolversTypes['LoanAccountability']>, ParentType, ContextType, RequireFields<MutationUpdateLoanAccountabilityArgs, 'loanAccountabilityInput'>>;
  updateRelatedPersonQuestionnaire?: Resolver<Maybe<ResolversTypes['RelatedPerson']>, ParentType, ContextType, RequireFields<MutationUpdateRelatedPersonQuestionnaireArgs, 'companyInfoId' | 'creditAnalysisId' | 'relatedPersonInput'>>;
  updateSignerChecklist?: Resolver<Maybe<ResolversTypes['Signer']>, ParentType, ContextType, RequireFields<MutationUpdateSignerChecklistArgs, 'checklistInput' | 'loanApplicationId' | 'signerId'>>;
  uploadLoanAccountabilityDoc?: Resolver<Maybe<ResolversTypes['LoanAccountability']>, ParentType, ContextType, RequireFields<MutationUploadLoanAccountabilityDocArgs, 'base64Document' | 'filename' | 'loanApplicationId'>>;
  uploadPreQualifiedProposalDoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationUploadPreQualifiedProposalDocArgs, 'base64Document' | 'filename'>>;
  upsertSigner?: Resolver<Maybe<ResolversTypes['Signer']>, ParentType, ContextType, RequireFields<MutationUpsertSignerArgs, 'loanApplicationId' | 'signerInput'>>;
};

export type PreQualifiedLoanResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreQualifiedLoan'] = ResolversParentTypes['PreQualifiedLoan']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  borrowerInfo?: Resolver<Maybe<ResolversTypes['BorrowerInfo']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  document?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasReceivables?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  interestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isLowTicket?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  loanApplicationStatus?: Resolver<Maybe<ResolversTypes['LoanApplicationStatus']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['PreQualifiedLoanOwner']>, ParentType, ContextType>;
  predefinedComissionPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PreQualifiedLoanStatus']>, ParentType, ContextType>;
  term?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreQualifiedPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreQualifiedPagination'] = ResolversParentTypes['PreQualifiedPagination']> = {
  currentPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  records?: Resolver<Maybe<Array<Maybe<ResolversTypes['PreQualifiedLoan']>>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PredefinedMotiveResolvers<ContextType = any, ParentType extends ResolversParentTypes['PredefinedMotive'] = ResolversParentTypes['PredefinedMotive']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  internal?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  skipChecklist?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  suggestionType?: Resolver<Maybe<ResolversTypes['SuggestionType']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  accountabilityDocumentPreassignedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryAccountabilityDocumentPreassignedUrlArgs, 'fileName' | 'loanAccountabilityId'>>;
  antiFraud?: Resolver<Maybe<ResolversTypes['AntiFraud']>, ParentType, ContextType, RequireFields<QueryAntiFraudArgs, 'loanApplicationId'>>;
  authoritiesByUsername?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuthorityLevel']>>>, ParentType, ContextType, RequireFields<QueryAuthoritiesByUsernameArgs, 'username'>>;
  banks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Bank']>>>, ParentType, ContextType>;
  citiesByStateId?: Resolver<Maybe<Array<Maybe<ResolversTypes['City']>>>, ParentType, ContextType, RequireFields<QueryCitiesByStateIdArgs, 'stateId'>>;
  collections?: Resolver<Maybe<Array<Maybe<ResolversTypes['Collection']>>>, ParentType, ContextType, RequireFields<QueryCollectionsArgs, 'loanApplicationId' | 'source'>>;
  companyInfo?: Resolver<Maybe<ResolversTypes['CompanyInfo']>, ParentType, ContextType, RequireFields<QueryCompanyInfoArgs, 'loanApplicationId'>>;
  companyInfoSigner?: Resolver<Maybe<ResolversTypes['Signer']>, ParentType, ContextType, RequireFields<QueryCompanyInfoSignerArgs, 'loanApplicationId' | 'signerId'>>;
  companyInfoSigners?: Resolver<Maybe<Array<Maybe<ResolversTypes['Signer']>>>, ParentType, ContextType, RequireFields<QueryCompanyInfoSignersArgs, 'loanApplicationId'>>;
  companyInfos?: Resolver<Maybe<ResolversTypes['CompanyInfoPagination']>, ParentType, ContextType, RequireFields<QueryCompanyInfosArgs, 'queryParams'>>;
  creditAnalysts?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditAnalyst']>>>, ParentType, ContextType>;
  getProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['LegacyProduct']>>>, ParentType, ContextType>;
  isProcessingCreditAutomation?: Resolver<Maybe<ResolversTypes['AutomaticAuthorityDecisionCache']>, ParentType, ContextType, RequireFields<QueryIsProcessingCreditAutomationArgs, 'companyInfoId' | 'creditAnalysisId'>>;
  latestPreQualifiedLoan?: Resolver<Maybe<ResolversTypes['PreQualifiedLoan']>, ParentType, ContextType, RequireFields<QueryLatestPreQualifiedLoanArgs, 'owner' | 'preQualifiedLoanId'>>;
  loanAccountability?: Resolver<Maybe<ResolversTypes['LoanAccountability']>, ParentType, ContextType, RequireFields<QueryLoanAccountabilityArgs, 'loanApplicationId'>>;
  preQualifiedLoan?: Resolver<Maybe<ResolversTypes['PreQualifiedLoan']>, ParentType, ContextType, RequireFields<QueryPreQualifiedLoanArgs, 'id'>>;
  preQualifiedLoansByDocument?: Resolver<Maybe<Array<Maybe<ResolversTypes['PreQualifiedLoan']>>>, ParentType, ContextType, RequireFields<QueryPreQualifiedLoansByDocumentArgs, 'document'>>;
  preQualifiedProposalDocumentPreAssignedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preQualifiedProposalMessageCountInQueue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  preQualifiedProposals?: Resolver<Maybe<ResolversTypes['PreQualifiedPagination']>, ParentType, ContextType, RequireFields<QueryPreQualifiedProposalsArgs, 'queryParams'>>;
  predefinedMotives?: Resolver<Maybe<Array<Maybe<ResolversTypes['PredefinedMotive']>>>, ParentType, ContextType, RequireFields<QueryPredefinedMotivesArgs, never>>;
  questionsFromTemplate?: Resolver<Maybe<Array<Maybe<ResolversTypes['Question']>>>, ParentType, ContextType, RequireFields<QueryQuestionsFromTemplateArgs, never>>;
  states?: Resolver<Maybe<Array<Maybe<ResolversTypes['State']>>>, ParentType, ContextType>;
};

export type QuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Question'] = ResolversParentTypes['Question']> = {
  answers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Answer']>>>, ParentType, ContextType>;
  asking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  questionnaireType?: Resolver<Maybe<ResolversTypes['QuestionnaireType']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedPersonResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelatedPerson'] = ResolversParentTypes['RelatedPerson']> = {
  documentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questionnaire?: Resolver<Maybe<Array<Maybe<ResolversTypes['Question']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RelatedPersonType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Signer'] = ResolversParentTypes['Signer']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  administrator?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  birthDay?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  birthPlace?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checklist?: Resolver<Maybe<ResolversTypes['Checklist']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['Gender']>, ParentType, ContextType>;
  guarantor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hiddenDocument?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  identityIssuingBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identityIssuingBodyUf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identityNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyRelationship?: Resolver<Maybe<ResolversTypes['Credit_LegacyRelationship']>, ParentType, ContextType>;
  legalRepresentative?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  maritalStatus?: Resolver<Maybe<ResolversTypes['MaritalStatus']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nationalRegistryOfForeigners?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nationality?: Resolver<Maybe<ResolversTypes['Nationality']>, ParentType, ContextType>;
  profession?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  shareHolder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sharePercentage?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  spouse?: Resolver<Maybe<ResolversTypes['Spouse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpouseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Spouse'] = ResolversParentTypes['Spouse']> = {
  documentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StateResolvers<ContextType = any, ParentType extends ResolversParentTypes['State'] = ResolversParentTypes['State']> = {
  abbreviation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorthyCreditResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorthyCredit'] = ResolversParentTypes['WorthyCredit']> = {
  candidateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  questionnaireUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  results?: Resolver<Maybe<ResolversTypes['WorthyCreditResults']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['WorthyCreditStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorthyCreditResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorthyCreditResults'] = ResolversParentTypes['WorthyCreditResults']> = {
  candidateComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  imPass?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  overallPass?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  overallScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AccountabilityDocument?: AccountabilityDocumentResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  AlienatedItem?: AlienatedItemResolvers<ContextType>;
  Answer?: AnswerResolvers<ContextType>;
  AntiFraud?: AntiFraudResolvers<ContextType>;
  Applicant?: ApplicantResolvers<ContextType>;
  ApplicantResultType?: ApplicantResultTypeResolvers<ContextType>;
  AuthorityDecisionReason?: AuthorityDecisionReasonResolvers<ContextType>;
  AutomaticAuthorityDecision?: AutomaticAuthorityDecisionResolvers<ContextType>;
  AutomaticAuthorityDecisionCache?: AutomaticAuthorityDecisionCacheResolvers<ContextType>;
  Bank?: BankResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  BankAccountInfo?: BankAccountInfoResolvers<ContextType>;
  Borrower?: BorrowerResolvers<ContextType>;
  BorrowerInfo?: BorrowerInfoResolvers<ContextType>;
  ChangeTracker?: ChangeTrackerResolvers<ContextType>;
  Checklist?: ChecklistResolvers<ContextType>;
  ChecklistItem?: ChecklistItemResolvers<ContextType>;
  City?: CityResolvers<ContextType>;
  Collection?: CollectionResolvers<ContextType>;
  CompanyInfo?: CompanyInfoResolvers<ContextType>;
  CompanyInfoPagination?: CompanyInfoPaginationResolvers<ContextType>;
  CreditAnalysis?: CreditAnalysisResolvers<ContextType>;
  CreditAnalyst?: CreditAnalystResolvers<ContextType>;
  CreditAnalystAuthorityLimits?: CreditAnalystAuthorityLimitsResolvers<ContextType>;
  CreditOpinion?: CreditOpinionResolvers<ContextType>;
  Credit_LegacyRelationship?: Credit_LegacyRelationshipResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  Decimal?: GraphQLScalarType;
  Document?: DocumentResolvers<ContextType>;
  DocumentUploadS3?: DocumentUploadS3Resolvers<ContextType>;
  InvalidApplicant?: InvalidApplicantResolvers<ContextType>;
  InvalidQuestionsCount?: InvalidQuestionsCountResolvers<ContextType>;
  LegacyBizu?: LegacyBizuResolvers<ContextType>;
  LegacyChecklistScore?: LegacyChecklistScoreResolvers<ContextType>;
  LegacyClearSaleData?: LegacyClearSaleDataResolvers<ContextType>;
  LegacyClearSaleInsight?: LegacyClearSaleInsightResolvers<ContextType>;
  LegacyClearSaleRating?: LegacyClearSaleRatingResolvers<ContextType>;
  LegacyClearSaleResults?: LegacyClearSaleResultsResolvers<ContextType>;
  LegacyClearSaleScore?: LegacyClearSaleScoreResolvers<ContextType>;
  LegacyCreditWorthiness?: LegacyCreditWorthinessResolvers<ContextType>;
  LegacyLoanApplication?: LegacyLoanApplicationResolvers<ContextType>;
  LegacyProduct?: LegacyProductResolvers<ContextType>;
  LegacyProposal?: LegacyProposalResolvers<ContextType>;
  LegacyRenewalInformation?: LegacyRenewalInformationResolvers<ContextType>;
  LegacySerasa?: LegacySerasaResolvers<ContextType>;
  LegacyStatementScore?: LegacyStatementScoreResolvers<ContextType>;
  LegacyStatementScoreBigGuys?: LegacyStatementScoreBigGuysResolvers<ContextType>;
  Liveness?: LivenessResolvers<ContextType>;
  LivenessSharedUrl?: LivenessSharedUrlResolvers<ContextType>;
  LoanAccountability?: LoanAccountabilityResolvers<ContextType>;
  LoanApplicationRef?: LoanApplicationRefResolvers<ContextType>;
  Loan_LegacyRelationship?: Loan_LegacyRelationshipResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  PreQualifiedLoan?: PreQualifiedLoanResolvers<ContextType>;
  PreQualifiedPagination?: PreQualifiedPaginationResolvers<ContextType>;
  PredefinedMotive?: PredefinedMotiveResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Question?: QuestionResolvers<ContextType>;
  RelatedPerson?: RelatedPersonResolvers<ContextType>;
  Signer?: SignerResolvers<ContextType>;
  Spouse?: SpouseResolvers<ContextType>;
  State?: StateResolvers<ContextType>;
  WorthyCredit?: WorthyCreditResolvers<ContextType>;
  WorthyCreditResults?: WorthyCreditResultsResolvers<ContextType>;
};

